import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={571}
      height={380.44}
      viewBox="0 0 571 380.44"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__i"
          y1={0.5}
          x2={1}
          y2={0.5}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fee543" stopOpacity={0.22} />
          <stop offset={1} stopColor="#fee543" stopOpacity={0.22} />
        </linearGradient>
        <linearGradient
          id="prefix__a"
          x1={1.639}
          y1={-0.538}
          x2={0.192}
          y2={0.96}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#4042e2" />
          <stop offset={1} stopColor="#4f52ff" />
        </linearGradient>
        <linearGradient
          id="prefix__j"
          x1={4.371}
          y1={-0.645}
          x2={-1.152}
          y2={1.062}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__b"
          y1={0.5}
          x2={1}
          y2={0.5}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#dae3fe" />
          <stop offset={1} stopColor="#e9effd" />
        </linearGradient>
        <linearGradient
          id="prefix__k"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__l"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__m"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__n"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__o"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__p"
          x1={0}
          y1={0.499}
          x2={1}
          y2={0.499}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__q"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__r"
          x1={0.735}
          y1={-1.375}
          x2={0.328}
          y2={1.606}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#71606e" />
          <stop offset={1} stopColor="#71606e" />
        </linearGradient>
        <linearGradient
          id="prefix__c"
          x1={0.693}
          y1={-34.961}
          x2={0.397}
          y2={19.07}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#09005d" />
          <stop offset={1} stopColor="#1a0f91" />
        </linearGradient>
        <linearGradient
          id="prefix__s"
          x1={0.65}
          y1={-21.973}
          x2={0.405}
          y2={14.338}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__t"
          x1={0.64}
          y1={-20.764}
          x2={0.399}
          y2={15.493}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__u"
          x1={0.641}
          y1={-19.733}
          x2={0.386}
          y2={16.793}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__v"
          x1={0.575}
          y1={-0.417}
          x2={0.467}
          y2={0.686}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ffc840" />
          <stop offset={1} stopColor="#ffc840" />
        </linearGradient>
        <linearGradient
          id="prefix__d"
          x1={0.464}
          y1={0.304}
          x2={0.798}
          y2={2.218}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#e1473d" />
          <stop offset={1} stopColor="#e9605a" />
        </linearGradient>
        <linearGradient
          id="prefix__w"
          x1={0.465}
          y1={0.307}
          x2={0.799}
          y2={2.221}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__x"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__y"
          x1={1.065}
          y1={-0.897}
          x2={0.104}
          y2={1.481}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__e"
          x1={-5.609}
          y1={3.475}
          x2={-5.622}
          y2={0.75}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fe7062" />
          <stop offset={1} stopColor="#ff928e" />
        </linearGradient>
        <linearGradient
          id="prefix__z"
          x1={-44.389}
          y1={27.916}
          x2={-44.431}
          y2={24.732}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__A"
          x1={-147.891}
          y1={11.487}
          x2={-147.19}
          y2={15.695}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__B"
          x1={-44.393}
          y1={27.649}
          x2={-44.436}
          y2={24.465}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__C"
          x1={-147.712}
          y1={10.428}
          x2={-147.012}
          y2={14.304}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__D"
          x1={-12.224}
          y1={7.394}
          x2={-12.306}
          y2={9.538}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__E"
          x1={0.48}
          y1={-0.396}
          x2={0.51}
          y2={1.088}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__F"
          x1={-27.728}
          y1={4.653}
          x2={-27.989}
          y2={7.048}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__G"
          x1={-37.328}
          y1={8.425}
          x2={-36.328}
          y2={8.425}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__f"
          x1={18.685}
          y1={42.979}
          x2={18.343}
          y2={47.388}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#50e7b7" />
          <stop offset={1} stopColor="#323992" />
        </linearGradient>
        <linearGradient
          id="prefix__H"
          x1={18.874}
          y1={43.009}
          x2={18.531}
          y2={47.418}
          xlinkHref="#prefix__f"
        />
        <linearGradient
          id="prefix__I"
          x1={9.776}
          y1={9.646}
          x2={10.446}
          y2={8.868}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__J"
          x1={11.182}
          y1={8.57}
          x2={9.131}
          y2={11.669}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__K"
          x1={25.427}
          y1={13.448}
          x2={22.859}
          y2={16.369}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__L"
          x1={5.655}
          y1={6.295}
          x2={6.326}
          y2={5.516}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__M"
          x1={6.918}
          y1={5.101}
          x2={4.867}
          y2={8.2}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__N"
          x1={15.384}
          y1={7.921}
          x2={12.818}
          y2={10.841}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__O"
          x1={5.219}
          y1={6.28}
          x2={5.889}
          y2={5.501}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__P"
          x1={6.467}
          y1={5.086}
          x2={4.415}
          y2={8.185}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__Q"
          x1={14.338}
          y1={7.898}
          x2={11.77}
          y2={10.817}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__R"
          x1={7.463}
          y1={8.294}
          x2={8.133}
          y2={7.516}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__S"
          x1={8.788}
          y1={7.17}
          x2={6.737}
          y2={10.269}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__T"
          x1={19.788}
          y1={11.213}
          x2={17.221}
          y2={14.132}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__U"
          x1={1.475}
          y1={-0.239}
          x2={-5.298}
          y2={4.039}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__V"
          x1={2.163}
          y1={0.18}
          x2={-17.934}
          y2={3.502}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__W"
          x1={0.422}
          y1={0.521}
          x2={4.768}
          y2={1.269}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__X"
          x1={1.516}
          y1={0.537}
          x2={14.361}
          y2={1.16}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__Y"
          x1={0.003}
          y1={0.089}
          x2={2.726}
          y2={4.366}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__g"
          x1={-68.327}
          y1={-0.843}
          x2={-68.833}
          y2={2.39}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#a22b25" />
          <stop offset={1} stopColor="#c0423c" />
        </linearGradient>
        <linearGradient
          id="prefix__Z"
          x1={0.076}
          y1={-0.16}
          x2={2.192}
          y2={5.238}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__aa"
          x1={-59.236}
          y1={-1.681}
          x2={-59.716}
          y2={1.035}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__ab"
          x1={0.944}
          y1={0.161}
          x2={-0.657}
          y2={1.418}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__ac"
          x1={0.185}
          y1={0.861}
          x2={1.063}
          y2={0.004}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__ad"
          x1={0.514}
          y1={0.514}
          x2={-0.826}
          y2={2.534}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__ae"
          x1={-3.73}
          y1={0.426}
          x2={-5.515}
          y2={0.582}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__af"
          x1={-3.852}
          y1={-0.153}
          x2={-3.173}
          y2={0.651}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__ag"
          x1={-15.316}
          y1={0.093}
          x2={-22.621}
          y2={0.604}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__ah"
          x1={-8.402}
          y1={0.773}
          x2={-9.632}
          y2={1.512}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__ai"
          x1={-1.832}
          y1={-1.591}
          x2={-2.648}
          y2={1.329}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__aj"
          x1={-8.897}
          y1={0.728}
          x2={-10.314}
          y2={4.765}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__ak"
          x1={-3.792}
          y1={-3.841}
          x2={-5.163}
          y2={5.698}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__al"
          x1={0.735}
          y1={-0.459}
          x2={0.39}
          y2={1.132}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__am"
          x1={0.24}
          y1={0.606}
          x2={4.914}
          y2={-1.282}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__h"
          x1={-12.017}
          y1={0.501}
          x2={-11.017}
          y2={0.501}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ff928e" />
          <stop offset={1} stopColor="#feb3b1" />
        </linearGradient>
        <linearGradient
          id="prefix__an"
          x1={0.459}
          y1={0.771}
          x2={-1.482}
          y2={4.666}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__ao"
          x1={0.428}
          y1={0.579}
          x2={-0.9}
          y2={2.397}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__ap"
          x1={-20.373}
          y1={0.833}
          x2={-20.652}
          y2={-0.234}
          xlinkHref="#prefix__h"
        />
        <linearGradient
          id="prefix__aq"
          x1={-5.223}
          y1={0.34}
          x2={-4.151}
          y2={0.762}
          xlinkHref="#prefix__h"
        />
        <linearGradient
          id="prefix__ar"
          x1={30.965}
          y1={36.222}
          x2={31.871}
          y2={36.222}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__as"
          x1={-16.586}
          y1={-0.608}
          x2={-13.616}
          y2={0.819}
          xlinkHref="#prefix__h"
        />
        <linearGradient
          id="prefix__at"
          x1={-0.637}
          y1={-1.363}
          x2={-4.362}
          y2={1.237}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__au"
          x1={32.34}
          y1={0.5}
          x2={33.34}
          y2={0.5}
          xlinkHref="#prefix__h"
        />
        <linearGradient
          id="prefix__av"
          x1={-8.956}
          y1={-0.771}
          x2={-4.944}
          y2={1.483}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__aw"
          x1={16.581}
          y1={0.5}
          x2={17.581}
          y2={0.5}
          xlinkHref="#prefix__h"
        />
        <linearGradient
          id="prefix__ax"
          x1={-5.789}
          y1={1.073}
          x2={-3.842}
          y2={-0.534}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__ay"
          x1={0.547}
          y1={0.42}
          x2={-0.13}
          y2={1.585}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__az"
          x1={0}
          y1={0.503}
          x2={1}
          y2={0.503}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__aA"
          x1={0}
          y1={0.503}
          x2={1}
          y2={0.503}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__aB"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__aC"
          x1={0.666}
          y1={0.342}
          x2={-0.743}
          y2={2.221}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__aD"
          x1={-11.745}
          y1={-8.373}
          x2={-12.688}
          y2={-6.206}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__aE"
          x1={0.934}
          y1={-0.798}
          x2={0.715}
          y2={-0.138}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__aF"
          x1={0.573}
          y1={0.369}
          x2={-1.371}
          y2={3.877}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__aG"
          x1={0.075}
          y1={1.441}
          x2={-2.33}
          y2={5.652}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__aH"
          x1={0.484}
          y1={-2.107}
          x2={0.5}
          y2={0.076}
          xlinkHref="#prefix__h"
        />
        <linearGradient
          id="prefix__aI"
          x1={0.454}
          y1={-2.65}
          x2={0.507}
          y2={0.712}
          xlinkHref="#prefix__h"
        />
        <linearGradient
          id="prefix__aJ"
          x1={3.051}
          y1={-0.193}
          x2={-4.732}
          y2={1.919}
          xlinkHref="#prefix__d"
        />
      </defs>
      <g data-name="Asset 1">
        <g data-name="Layer 2">
          <path
            data-name="Path 9349"
            d="M557.806 72.9c-14.4-29.226-46.011-51.2-76.781-44.462-18.424 4.037-36.726 17.583-54.4 10.784-12.734-4.9-19.92-18.8-30.624-27.52-16.472-13.422-39.855-13.265-59.931-7.25s-38.453 17.072-58.282 23.909a147.57 147.57 0 01-104.549-3.5c-14.5-6.1-28.063-14.517-42.82-19.885s-31.491-7.452-45.737-.74S60.224 28.51 65.166 44.009C66.153 47.1 67.7 50.13 67.5 53.4c-.325 5.213-5.142 9.032-10.012 10.19s-9.948.4-14.941.532C20.134 64.714.105 86.1 0 109.538c-.088 19.441 11.377 36.524 21.181 53.042s18.61 36.337 12.774 54.8c-3.46 10.943-11.585 19.5-16.907 29.6-13.8 26.171-6.422 60.821 12.843 82.9S78 362.755 106.477 365.326s57.029-2.257 85.244-7.028 56.789-9.517 85.249-6.784c0 0 73.9 10.315 130.7 2.616 11.891-1.613 63.871 1.552 68.9-9.831 4.242-9.613.434-20.878 1.307-31.425 1.259-15.2 12.165-27.646 24.056-36.484s25.383-15.412 36.1-25.764c20.96-20.255 28.071-51.605 31.2-81.268 3.426-32.677 2.981-67.231-11.427-96.458z"
            transform="translate(.002 -.01)"
            fill="#fee54329"
          />
          <path
            data-name="Path 9350"
            d="M560.905 139.428c-5.056 22.738-39.443 153.714-157.868 139.9 0 0 2.3-92.709 155.587-142.281a1.9 1.9 0 012.281 2.381z"
            fill="#bdd0fb"
          />
          <path
            data-name="Path 9351"
            d="M544.704 154.565c-3.9 6.265-8.013 12.351-12.242 18.384s-8.572 11.96-13.04 17.8-9.08 11.585-13.812 17.224-9.58 11.178-14.637 16.556-10.177 10.664-15.558 15.7-10.874 9.985-16.662 14.579c-11.5 9.256-23.952 17.493-37.583 23.56a1.682 1.682 0 11-1.371-3.072h.029c13.307-5.751 25.661-13.7 37.125-22.725 5.767-4.474 11.268-9.3 16.649-14.249s10.56-10.134 15.616-15.436 9.956-10.744 14.728-16.306 9.418-11.231 13.942-17 8.924-11.638 13.195-17.6 8.444-12 12.375-18.169a.713.713 0 011.206.759z"
            fill="#dce5fe"
          />
          <path
            data-name="Path 9352"
            d="M8.468 233.492c9.152 18.8 66.442 125.991 166.959 89.276 0 0-21.306-80.464-165.463-91.831a1.71 1.71 0 00-1.496 2.555z"
            fill="#bdd0fb"
          />
          <path
            data-name="Path 9353"
            d="M26.613 242.478c4.716 4.572 9.621 8.979 14.581 13.306s10.033 8.516 15.169 12.631 10.379 8.088 15.7 11.952 10.728 7.617 16.25 11.178 11.111 7.034 16.846 10.233 11.537 6.281 17.509 8.992c1.477.713 2.983 1.357 4.49 2s3 1.331 4.524 1.9l4.575 1.783 4.636 1.61a134.872 134.872 0 0018.946 4.857h.019a1.331 1.331 0 11-.46 2.616 154.2 154.2 0 01-37.684-12.708c-6.009-2.8-11.837-5.953-17.578-9.24s-11.342-6.816-16.854-10.462-10.911-7.452-16.218-11.4-10.525-7.984-15.651-12.149-10.158-8.436-15.1-12.817-9.791-8.835-14.5-13.487a.562.562 0 01.785-.8z"
            fill="#dce5fe"
          />
          <path
            data-name="Path 9354"
            d="M492.199 29.804c4.524 22.371 25.45 153.623-94.186 195.4 0 0-36.029-82.86 91.016-196.457a1.929 1.929 0 013.17 1.062z"
            fill="#bdd0fb"
          />
          <path
            data-name="Path 9355"
            d="M482.613 50.562c-1.142 7.617-2.61 15.153-4.215 22.672s-3.406 14.988-5.392 22.413-4.154 14.8-6.52 22.118c-.6 1.826-1.174 3.662-1.81 5.477l-1.89 5.448c-1.331 3.611-2.624 7.231-4.061 10.8-1.373 3.593-2.9 7.124-4.4 10.672l-2.36 5.253c-.772 1.762-1.65 3.478-2.47 5.219a223.718 223.718 0 01-11.036 20.306l-1.5 2.47-1.6 2.419-1.6 2.416-.8 1.208-.844 1.176-3.374 4.705-3.6 4.548a131.54 131.54 0 01-16.159 16.652 1.184 1.184 0 11-1.538-1.8 129.174 129.174 0 0015.981-16.234l3.577-4.455 3.38-4.617.841-1.155.8-1.19 1.6-2.376 1.6-2.379 1.506-2.435a222.044 222.044 0 0011.09-20.056c.828-1.725 1.714-3.42 2.494-5.168l2.4-5.219c1.512-3.516 3.058-7.015 4.453-10.581 1.456-3.542 2.773-7.138 4.122-10.722l1.922-5.413c.647-1.8 1.227-3.627 1.844-5.44q3.614-10.911 6.653-22t5.544-22.315c1.653-7.481 3.177-15.007 4.367-22.562a.5.5 0 11.99.152z"
            fill="#dce5fe"
          />
          <path
            data-name="Path 9356"
            d="M6.702 78.947c3.4 23.071 28.793 156.484 161.929 154.584 0 0 6.552-92.238-159.146-156.721a2.033 2.033 0 00-2.784 2.137z"
            fill="#91b3fa"
          />
          <path
            data-name="Path 9357"
            d="M24.243 95.118c3.832 6.853 7.968 13.557 12.242 20.167s8.708 13.12 13.306 19.513a413.98 413.98 0 0029.673 36.819 270.407 270.407 0 0034.637 32.327c3.13 2.424 6.355 4.732 9.637 6.957s6.653 4.333 10.086 6.3a129.658 129.658 0 0021.6 10.02.743.743 0 01.455.969.8.8 0 01-1 .455 131.162 131.162 0 01-21.812-10.233q-5.2-3.015-10.145-6.406c-3.295-2.257-6.531-4.593-9.668-7.05a272.568 272.568 0 01-34.634-32.627 409.849 409.849 0 01-29.57-37.037q-6.866-9.644-13.237-19.608c-4.242-6.653-8.346-13.368-12.162-20.266a.317.317 0 01.136-.434.33.33 0 01.444.125z"
            fill="#dce5fe"
          />
          <path
            data-name="Path 9358"
            d="M45.184 2.494c-2.071 20.548-9.256 140.62 102.2 167.608 0 0 25.083-77.83-99.429-168.849a1.748 1.748 0 00-2.768 1.24z"
            fill="#bdd0fb"
          />
          <path
            data-name="Path 9359"
            d="M56.444 20.117c1.985 6.281 4.1 12.527 6.27 18.751s4.415 12.423 6.73 18.594c4.628 12.34 9.535 24.58 14.813 36.654s10.911 23.986 17.2 35.56q4.673 8.694 9.977 17.016a165.537 165.537 0 0011.465 15.986.846.846 0 11-1.309 1.064 167.516 167.516 0 01-11.482-16.215q-5.285-8.4-9.927-17.171c-6.227-11.662-11.806-23.646-17.032-35.77S73.1 70.171 68.541 57.786q-3.422-9.285-6.624-18.653c-2.129-6.243-4.21-12.508-6.161-18.813a.36.36 0 01.687-.216z"
            fill="#dce5fe"
          />
          <path
            data-name="Path 9360"
            d="M1523.666 678.133c1.536 1.192 43.717-1.863 61.436 1.8 0 0 13.735-59.927-25.7-62.274s-53.109 21.982-53.109 21.982z"
            transform="translate(-1105.421 -453.168)"
            fill="#4F52FF"
          />
          <path
            data-name="Path 9361"
            d="M376.59 161.663l77.388 2.824s-28.21.386-25.077 36.05 19.015 139.806-21.343 139.91-41-18.331-41-18.331z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 9362"
            d="M1219.1 525.245l29.913-6.965s20-1.8 22.706 15.981 1.922 123.1 1.065 144.814 1.19 38.426 13.413 41.687l-88.914 1.528z"
            transform="translate(-878.648 -380.316)"
            fill="#4F52FF"
          />
          <path
            data-name="Path 9363"
            d="M279.636 146.373s54.469 2.994 90.726-8.41c0 0-24.1-1.65-24.1 54 0 42.549 6.31 123.75.8 139.186s-26.1 36.135-55.645 18.326-11.781-203.102-11.781-203.102z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 9364"
            d="M265.156 62.943s60.1 6.549 67.839-3.635c0 0-6.158-18.334-24.447-17.115s-43.392 20.75-43.392 20.75z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 9365"
            d="M69.703 83.562c5.24 58.894 16.234 183.464 21.024 244.145a27.286 27.286 0 0025.453 25.086c48.241 3.1 156.8 9.1 198.463 3.516a27.726 27.726 0 01-15.465-25.1l2.212-272.3c.077-9.621 9.66-16.535 18.672-13.157q8.516 3.194 12.923 13.546c-3.933-11.465-10.113-19.851-24.447-17.115 0 0-140.13 1.4-208.129 5.618a32.894 32.894 0 00-30.706 35.757z"
            fill="#91b3fa"
          />
          <g data-name="Group 473">
            <path
              data-name="Path 9366"
              d="M104.366 55.618l188.292-7.249c-7.768 57.484-4.49 174.581-1.528 289.962a18.12 18.12 0 0010.379 15.92s-125.589 1.448-179.552-2.379a27.2 27.2 0 01-24.958-23.113c-7.408-49.437-25.133-177.15-21.444-244.761a30.022 30.022 0 0128.811-28.38z"
              fill="#bdd0fb"
            />
          </g>
          <path
            data-name="Path 9367"
            d="M429.906 983.313l1.951 16.74c.359 3.069 3.425 5.466 7.185 5.626l11.925.5c4.3.184 7.909-2.587 7.947-6.1l.2-18.033c.04-3.619-3.726-6.507-8.144-6.259l-14.073.8c-4.231.227-7.39 3.266-6.991 6.726z"
            transform="translate(-315.47 -716.095)"
            opacity={0.4}
            fill="#fff"
          />
          <path
            data-name="Path 9368"
            d="M576.229 981.882c19.859-.381 96.1-1.946 115.346-2.339a4.236 4.236 0 014.388 4.216 4.229 4.229 0 01-4.183 4.122l-115.28 2.882a4.258 4.258 0 01-4.383-3.681l-.067-.532a4.21 4.21 0 014.178-4.668z"
            transform="translate(-419.793 -718.858)"
            opacity={0.4}
            fill="#fff"
          />
          <path
            data-name="Path 9369"
            d="M580.311 1063.153a1.743 1.743 0 001.528.883l75.618-.835a1.759 1.759 0 001.727-1.754l.056-5.056a1.759 1.759 0 00-1.791-1.791l-73.521 1.969a4.387 4.387 0 00-3.617 6.584z"
            transform="translate(-425.439 -773.942)"
            opacity={0.4}
            fill="#fff"
          />
          <path
            data-name="Path 9370"
            d="M421.715 810.374l1.953 16.62c.357 3.047 3.422 5.426 7.186 5.589l11.923.5c4.3.181 7.909-2.568 7.947-6.054l.2-17.9c.037-3.6-3.726-6.464-8.144-6.217l-14.073.78c-4.235.239-7.394 3.257-6.992 6.682z"
            transform="translate(-309.458 -589.223)"
            opacity={0.4}
            fill="#fff"
          />
          <path
            data-name="Path 9371"
            d="M568.01 809.022c19.861-.38 96.1-1.945 115.349-2.339a4.237 4.237 0 014.389 4.216 4.232 4.232 0 01-4.186 4.117l-115.28 2.884a4.258 4.258 0 01-4.381-3.686l-.066-.532a4.209 4.209 0 014.175-4.66z"
            transform="translate(-413.759 -592.001)"
            opacity={0.4}
            fill="#fff"
          />
          <path
            data-name="Path 9372"
            d="M572.134 890.389a1.845 1.845 0 001.6.881l79.144-.8a1.8 1.8 0 001.807-1.754l.056-5.056a1.8 1.8 0 00-1.863-1.794l-76.951 1.943a4.375 4.375 0 00-3.793 6.58z"
            transform="translate(-419.418 -647.178)"
            opacity={0.4}
            fill="#fff"
          />
          <path
            data-name="Path 9373"
            d="M617.641 640.033c18.033-.4 87.267-2.041 104.749-2.456a4.048 4.048 0 013.992 4.213 4.057 4.057 0 01-3.8 4.125l-104.7 3a3.989 3.989 0 01-3.976-3.675l-.058-.532a4.09 4.09 0 013.793-4.675z"
            transform="translate(-450.461 -467.901)"
            opacity={0.4}
            fill="#fff"
          />
          <path
            data-name="Path 9374"
            d="M600.256 721.448a1.783 1.783 0 001.562.881l77.22-.817a1.778 1.778 0 001.765-1.754l.053-5.056a1.778 1.778 0 00-1.828-1.794l-75.08 1.964a4.378 4.378 0 00-3.691 6.576z"
            transform="translate(-440.075 -523.184)"
            opacity={0.4}
            fill="#fff"
          />
          <path
            data-name="Path 9375"
            d="M624.221 474.165c18.145-.4 87.8-2.036 105.387-2.448a4.026 4.026 0 013.992 4.213 4.065 4.065 0 01-3.827 4.125l-105.313 2.991a3.994 3.994 0 01-3.992-3.675l-.058-.532a4.089 4.089 0 013.811-4.674z"
            transform="translate(-455.279 -346.181)"
            opacity={0.4}
            fill="#fff"
          />
          <path
            data-name="Path 9376"
            d="M625.26 555.6a1.642 1.642 0 001.453.881l71.94-.875a1.722 1.722 0 001.645-1.757l.056-5.056a1.717 1.717 0 00-1.7-1.791L628.7 549.02c-3.123.085-5 3.704-3.44 6.58z"
            transform="translate(-458.447 -401.43)"
            opacity={0.4}
            fill="#fff" 
          />
          <path
            data-name="Path 9377"
            d="M339.185 268.022a.915.915 0 01-.915-.9c0-.029-.058-2.927-.335-12.814a.918.918 0 111.834-.051c.266 9.911.333 12.8.333 12.83a.916.916 0 01-.9.934z"
            fill="#fff"
          />
          <path
            data-name="Path 9378"
            d="M338.519 243.868a.918.918 0 01-.916-.889c-.2-6.44-.5-13.573-.827-21.1-.439-10.187-.895-20.721-1.134-30.871-.634-26.783 3.784-37.064 7.6-40.984 2.073-2.129 3.811-2.185 3.992-2.185a.918.918 0 01.019 1.834c-.208 0-10.741 1.171-9.791 41.282.24 10.131.692 20.657 1.131 30.836.325 7.545.633 14.672.83 21.126a.918.918 0 01-.889.945z"
            fill="#fff"
          />
          <path
            data-name="Path 9379"
            d="M425.707 240.866a.918.918 0 01-.915-.862c0-.242-1.472-24.385-4.085-44.478-2.712-20.851 8.7-25.248 9.184-25.423a.918.918 0 01.63 1.722c-.431.16-10.507 4.162-7.984 23.465 2.621 20.157 4.082 44.364 4.1 44.606a.918.918 0 01-.862.969z"
            fill="#fff"
          />
          <path
            data-name="Path 9388"
            d="M456.341 679.507c-.04-.487-.532-.907-1.379-1.245.913-.506 1.421-1.046 1.379-1.576-.13-1.6-5.213-2.5-11.353-2.009s-11.012 2.2-10.885 3.8c.04.484.532.908 1.379 1.246-.913.5-1.421 1.046-1.379 1.575.04.487.532.907 1.379 1.245-.913.506-1.421 1.046-1.379 1.576.04.487.532.908 1.379 1.245-.913.506-1.421 1.046-1.379 1.576.059.711 1.086 1.283 2.744 1.655a13.941 13.941 0 00.043 1.735c.24 2.957 3.566 5.277 7.965 5.277s8.207-3.162 8.25-6.121a14.874 14.874 0 00-.085-1.937c2.105-.7 3.388-1.559 3.321-2.4-.04-.487-.532-.91-1.379-1.246.913-.506 1.421-1.046 1.379-1.578-.04-.484-.532-.907-1.379-1.245.913-.5 1.422-1.043 1.379-1.573z"
            transform="translate(-318.573 -495.029)"
            fill="#71606E"
          />
          <path
            data-name="Path 9389"
            d="M450.62 725.35a26.59 26.59 0 01-4.87-.4.149.149 0 01.056-.29 32.254 32.254 0 008.114.266 34.655 34.655 0 006.8-1.174.152.152 0 01.184.1.147.147 0 01-.1.184 35.263 35.263 0 01-6.861 1.184c-1.143.08-2.259.13-3.323.13z"
            transform="translate(-327.047 -531.142)"
            fill="#000"
          />
          <path
            data-name="Path 9390"
            d="M447.708 712.581a23.274 23.274 0 01-5.98-.647.149.149 0 01.08-.285 28.408 28.408 0 009.168.5 28.8 28.8 0 008.913-1.94.146.146 0 01.123.266 29.111 29.111 0 01-9.012 1.968 37.678 37.678 0 01-3.292.138z"
            transform="translate(-324.104 -521.197)"
            fill="#000"
          />
          <path
            data-name="Path 9391"
            d="M446.7 701.982a21.7 21.7 0 01-6.3-.759.149.149 0 01.093-.282 26.9 26.9 0 009.509.609 28.88 28.88 0 008.913-1.94.144.144 0 01.194.072.149.149 0 01-.072.2 28.5 28.5 0 01-9.011 1.953 37.983 37.983 0 01-3.326.147z"
            transform="translate(-323.129 -513.416)"
            fill="#000"
          />
          <path
            data-name="Path 9392"
            d="M449.443 691.478a25.555 25.555 0 01-5.323-.478.149.149 0 01.064-.29 30.592 30.592 0 008.516.341 29.022 29.022 0 008.867-1.916.146.146 0 11.12.266 29.22 29.22 0 01-8.963 1.945c-1.11.073-2.224.132-3.281.132z"
            transform="translate(-325.849 -505.722)"
            fill="#000"
          />
          <path
            data-name="Path 9393"
            d="M379.673 472.066a20.757 20.757 0 00-3.726-7.26 48.027 48.027 0 01-10.347-26.762c-1.064-18.6 15.436-27.912 30.48-26.648s29.9 12.471 28.279 29.775c-1 10.645-6.959 18.722-11.4 23.361a24.627 24.627 0 00-5.916 10.48c-1.331 4.806-4.5 10.8-12.032 11.162-9.738.474-13.786-8.609-15.338-14.108z"
            transform="translate(-268.263 -301.831)"
            fill="#FFC840"
          />
          <path
            data-name="Path 9394"
            d="M485.608 581.281l5.267-34.267c.109-.708.458-1.184.78-1.064s.492.8.383 1.5v.061l-6.009 33.95c-.045.266-.176.418-.29.359s-.169-.292-.131-.539z"
            transform="translate(-356.364 -400.645)"
            fill="#E1473D"
          />
          <path
            data-name="Path 9395"
            d="M447.283 582.332l-5.267-34.256c-.109-.708-.458-1.182-.777-1.065s-.492.8-.386 1.5a.539.539 0 010 .061l6 33.937c.042.266.173.418.287.362s.18-.292.143-.539z"
            transform="translate(-323.506 -401.425)"
            fill="#E1473D"
          />
          <path
            data-name="Path 9396"
            d="M134.474 143.441a.554.554 0 00-.692-.181l-2.927 1.371-1.017-2.9a.622.622 0 00-.357-.359.726.726 0 00-.9.266l-2.432 4.418-2.238-6.262a.717.717 0 00-.341-.383.878.878 0 00-1.107.218l-3.372 4.641a.407.407 0 00.12.585.567.567 0 00.719-.077l2.967-3.311 2.661 5.953a.479.479 0 00.237.232.559.559 0 00.7-.181l2.581-4.141.971 2.094v.019a.191.191 0 00.024.045.551.551 0 00.689.178l3.481-1.626a.412.412 0 00.237-.6z"
            fill="#fff"
            opacity={0.79}
          />
          <path
            data-name="Path 9397"
            d="M144.818 157.865a.267.267 0 01-.149-.048.25.25 0 01-.053-.351 38.872 38.872 0 002.47-3.75.25.25 0 11.434.25 39.571 39.571 0 01-2.5 3.8.243.243 0 01-.202.099z"
            fill="#fff"
            opacity={0.79}
          />
          <path
            data-name="Path 9398"
            d="M149.15 150.43a.234.234 0 01-.1-.021.248.248 0 01-.128-.327 31.687 31.687 0 00.713-24.024.251.251 0 11.455-.21 26.621 26.621 0 011.82 7.223 33.114 33.114 0 01-2.531 17.211.25.25 0 01-.229.148z"
            fill="#fff"
            opacity={0.79}
          />
          <path
            data-name="Path 9399"
            d="M868.91 1133.886a4.044 4.044 0 01-2.68-1.28c-3.694-3.393-4.538-8.713-4.745-13.685-1.788 2.017-3.627 3.976-5.442 5.911l-.583-.532c2-2.129 4.029-4.3 5.985-6.531a143.619 143.619 0 01.918-20.013 41.213 41.213 0 012.879-12.167 9.7 9.7 0 013-4.048 4.617 4.617 0 015.038-.306c1.562 1.048 1.988 3.074 2.172 4.5 1.11 8.617-2.259 16.524-5.277 21.642a72.991 72.991 0 01-7.914 10.68c.144 5.038.828 10.581 4.524 13.972A3.215 3.215 0 00869 1133.1c1.12-.04 1.991-1.064 2.693-2.081a54.529 54.529 0 007.106-14.187 14.592 14.592 0 011.24-4.32l.748.266q-.532 2.153-1.206 4.237a13.767 13.767 0 00.165 4.37c.157.8.822 3.372 2.789 3.747 1.48.282 2.927-.75 4.578-3.249l5.666-8.609-.506 2.175c-.3 1.29-.8 4.375 1.094 5.152 1.086.444 2.217-.192 3.414-.868a5.986 5.986 0 013.667-1.147l.41.053-.069.41c-.309 1.791-.152 3.992 1.312 4.322.961.213 1.738-.506 2.637-1.331a6.016 6.016 0 012.525-1.655l.186.777a5.388 5.388 0 00-2.169 1.466c-.977.9-1.985 1.834-3.353 1.53-1.879-.415-2.265-2.661-1.993-4.79a6.449 6.449 0 00-2.76 1.064c-1.312.74-2.661 1.5-4.112.91-1.365-.561-2.009-2.062-1.863-4.223l-3.425 5.208c-1.16 1.764-2.981 4.053-5.4 3.593-1.655-.314-2.927-1.951-3.42-4.373a14.338 14.338 0 01-.266-2.052 55.272 55.272 0 01-6.355 11.989c-.814 1.168-1.847 2.371-3.319 2.424zm2.2-52.489a4.276 4.276 0 00-2.422.8 8.935 8.935 0 00-2.731 3.726 40.5 40.5 0 00-2.815 11.93 142.785 142.785 0 00-.921 19.023 70.339 70.339 0 007.255-9.9c2.957-5.008 6.254-12.74 5.176-21.13-.266-2.031-.841-3.285-1.826-3.944a3.065 3.065 0 00-1.706-.505z"
            transform="translate(-627.796 -793.041)"
            fill="url(#prefix__x)"
          />
          <path
            data-name="Path 9400"
            d="M842.871 1164.823a26.051 26.051 0 1126.051-26.05 26.051 26.051 0 01-26.051 26.05zm0-51.544a25.5 25.5 0 1025.5 25.5 25.5 25.5 0 00-25.5-25.5z"
            transform="translate(-599.44 -816.595)"
            fill="url(#prefix__y)"
          />
          <path
            data-name="Path 9401"
            d="M1430.06 1152.6l1.8 42.464a13.822 13.822 0 0013.9 13.2l101.725-.447a9.975 9.975 0 009.847-8.591c1.48-10.743 3.308-29.958.841-47.948z"
            transform="translate(-1049.478 -844.893)"
            fill="url(#prefix__e)"
          />
          <path
            data-name="Path 9402"
            d="M398.969 360.74a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.732a.09.09 0 01.09.09.093.093 0 01-.09.094zm2.438 0a.093.093 0 010-.183h.732a.09.09 0 01.09.09.093.093 0 01-.09.094zm2.438 0a.093.093 0 01-.094-.041.094.094 0 010-.1.093.093 0 01.094-.041h.729a.088.088 0 01.093.09.094.094 0 01-.091.094zm2.438 0a.093.093 0 01-.094-.041.093.093 0 01.094-.143h.732a.09.09 0 110 .181h-.732zm2.438 0a.093.093 0 01-.093-.093.09.09 0 01.09-.09h.732a.093.093 0 01.093.09.09.09 0 01-.091.09h-.732zm2.438 0a.093.093 0 01-.093-.093.091.091 0 01.091-.09h.732a.09.09 0 110 .181h-.729zm-13.892 0a13.963 13.963 0 01-.729-.093.092.092 0 11.029-.181c.237.037.479.069.719.091a.093.093 0 010 .183zm16.327 0a.093.093 0 01-.09-.093.09.09 0 01.09-.09h.732a.09.09 0 110 .181h-.729zm2.438 0a.093.093 0 01-.09-.093.09.09 0 01.09-.09h.729a.09.09 0 110 .181h-.729zm2.438 0a.093.093 0 01-.09-.093.091.091 0 01.09-.09h.732a.09.09 0 01.09.09.086.086 0 01-.026.065.088.088 0 01-.065.026h-.732zm2.438 0a.09.09 0 010-.181h.732a.09.09 0 110 .181zm2.438 0a.09.09 0 110-.181h.729a.09.09 0 010 .181zm2.438 0a.09.09 0 110-.181h.732a.088.088 0 01.09.091.09.09 0 01-.09.09zm2.438 0a.09.09 0 110-.181h.732a.09.09 0 110 .181zm2.438 0a.09.09 0 01-.09-.09.087.087 0 01.09-.09h.74a.091.091 0 110 .181zm2.438 0a.09.09 0 110-.181h.729a.093.093 0 01.09.093.09.09 0 01-.09.09zm2.438 0a.09.09 0 110-.181h.729a.093.093 0 01.091.093.091.091 0 01-.091.09zm2.437 0a.093.093 0 01-.093-.09.09.09 0 01.09-.09h.732a.087.087 0 01.068.025.094.094 0 01-.065.158zm2.438 0a.093.093 0 01-.093-.09.09.09 0 01.09-.09h.732a.1.1 0 01.093.093.09.09 0 01-.09.09zm2.435 0a.09.09 0 010-.181h.732a.093.093 0 110 .183h-.734zm2.438 0a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.732a.1.1 0 01.093.09.092.092 0 01-.027.066.09.09 0 01-.066.027zm2.438 0a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.732a.093.093 0 010 .183zm2.438 0a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.732a.091.091 0 01.091.09.094.094 0 01-.091.094zm2.438 0a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.732a.09.09 0 01.09.09.094.094 0 01-.09.094zm2.438 0a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.732a.091.091 0 01.091.09.094.094 0 01-.091.094zm2.438 0a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.732a.09.09 0 01.09.09.093.093 0 01-.09.094zm2.438 0a.09.09 0 01-.091-.09.093.093 0 01.091-.093h.732a.085.085 0 01.091.09.094.094 0 01-.091.094zm2.438 0a.093.093 0 010-.183h.721a.09.09 0 01.09.09.094.094 0 01-.09.094zm2.438 0a.093.093 0 110-.183h.732a.093.093 0 010 .183zm2.438 0a.092.092 0 110-.183h.729a.093.093 0 110 .183zm2.438 0a.093.093 0 010-.183h.732a.093.093 0 110 .183zm2.438 0a.092.092 0 010-.183h.732a.093.093 0 01.093.09.1.1 0 01-.093.093zm2.435 0a.092.092 0 010-.183h.732a.1.1 0 01.093.09.1.1 0 01-.093.093zm2.438 0a.093.093 0 010-.183h.734a.09.09 0 01.09.09.088.088 0 01-.09.09h-.729zm2.438 0a.093.093 0 01-.091-.093.09.09 0 01.09-.09h.732a.09.09 0 110 .181h-.732zm2.438 0a.093.093 0 01-.09-.093.09.09 0 01.09-.09h.732a.09.09 0 110 .181h-.732zm2.438 0a.093.093 0 01-.091-.093.091.091 0 01.091-.09h.732a.09.09 0 110 .181h-.732zm2.437 0a.093.093 0 01-.09-.093.091.091 0 01.09-.09h.732a.09.09 0 110 .181h-.732zm2.438 0a.093.093 0 01-.09-.093.09.09 0 01.09-.09h.732a.09.09 0 110 .181h-.732zm2.437 0a.09.09 0 01-.09-.09.089.089 0 01.026-.065.088.088 0 01.065-.026h.745a.091.091 0 010 .181zm2.438 0a.09.09 0 110-.181h.732a.09.09 0 110 .181zm2.435-.064a.09.09 0 110-.181c.24-.027.482-.064.716-.107a.091.091 0 01.035.179 9.641 9.641 0 01-.729.109zm-101.592-.042h-.027a15.027 15.027 0 01-.7-.226.092.092 0 01.061-.173c.226.08.458.154.692.224a.09.09 0 01-.026.178zm103.953-.532a.091.091 0 01-.032-.176c.223-.085.45-.181.665-.285a.092.092 0 01.08.165c-.223.1-.45.2-.679.29a.207.207 0 01-.035-.413zm-106.215-.365h-.04a13.397 13.397 0 01-.647-.351.093.093 0 01-.035-.125.1.1 0 01.125-.035c.21.123.423.237.639.346a.09.09 0 01-.043.172zm108.357-.8a.091.091 0 01-.091-.106.092.092 0 01.038-.059c.194-.141.386-.29.569-.445a.093.093 0 01.12.141c-.189.157-.386.309-.583.452a.2.2 0 11-.053-.391zm-110.415-.506a.1.1 0 01-.056-.019 16.046 16.046 0 01-.572-.463.093.093 0 11.12-.141c.181.157.373.311.564.458a.093.093 0 01-.056.165zm112.192-1.15a.092.092 0 01-.058-.021.09.09 0 01-.033-.061.089.089 0 01.02-.067c.154-.187.3-.381.442-.575a.088.088 0 01.128-.021.091.091 0 01.021.125c-.141.2-.293.4-.45.585a.19.19 0 11-.07-.372zm-113.98-.5a.09.09 0 01-.07-.03c-.162-.181-.322-.37-.476-.562a.09.09 0 01.128-.128c.151.189.311.375.471.554a.092.092 0 010 .13.188.188 0 11-.053-.373zm115.279-1.552h-.04a.09.09 0 01-.047-.052.088.088 0 010-.07 5.856 5.856 0 00.266-.666.092.092 0 11.173.064 8.772 8.772 0 01-.285.679.184.184 0 11-.069-.362zm-116.735-.4a.093.093 0 01-.077-.043c-.128-.21-.25-.423-.367-.641a.092.092 0 01-.006-.07.092.092 0 01.168-.016c.115.213.234.426.362.631a.091.091 0 01-.032.125.2.2 0 11-.048-.394zm117.464-1.919h-.016a.093.093 0 01-.075-.106c.021-.121.04-.241.056-.359l.051-.362a.091.091 0 01.1-.078.1.1 0 01.08.1l-.05.359q-.024.183-.056.367a.173.173 0 01-.091-.333zm-118.531-.266a.088.088 0 01-.085-.059 12.869 12.869 0 01-.242-.7.092.092 0 01.061-.114.091.091 0 01.115.058c.072.231.152.46.237.689a.091.091 0 01-.053.117zm118.869-2.555a.087.087 0 01-.06-.034.089.089 0 01-.017-.067l.09-.726a.091.091 0 11.181.024c-.03.245-.062.487-.091.727a.093.093 0 01-.109.077zm-119.492-.2a.09.09 0 01-.088-.077c-.043-.24-.08-.484-.107-.729a.093.093 0 01.019-.067.09.09 0 01.061-.033.093.093 0 01.1.079c.029.24.064.482.1.719a.093.093 0 01-.015.069.092.092 0 01-.06.038zm119.8-2.219a.093.093 0 01-.083-.1l.085-.726a.091.091 0 01.181.021l-.082.727a.092.092 0 01-.041.071.09.09 0 01-.082.009zm-120.024-.207a.091.091 0 01-.093-.088l-.029-.729a.091.091 0 11.181 0l.032.729a.093.093 0 01-.088.1zm120.291-2.214a.093.093 0 01-.083-.1c.026-.242.051-.485.074-.727a.093.093 0 01.1-.082.09.09 0 01.062.032.091.091 0 01.021.067c-.027.245-.051.49-.077.729a.088.088 0 01-.12.082zm-120.384-.221a.09.09 0 01-.09-.088l-.032-.729a.093.093 0 01.088-.1.1.1 0 01.1.088l.029.729a.094.094 0 01-.088.1zm120.626-2.206a.094.094 0 01-.083-.1c.021-.239.043-.482.067-.726a.088.088 0 01.031-.063.092.092 0 01.15.079c-.021.245-.045.487-.067.729a.091.091 0 01-.039.068.093.093 0 01-.078.014zm-120.729-.229a.09.09 0 01-.09-.088l-.032-.729a.094.094 0 01.088-.1.1.1 0 01.1.088l.029.729a.093.093 0 01-.088.1zm120.942-2.2a.085.085 0 01-.062-.031.088.088 0 01-.02-.067c.019-.24.037-.484.059-.727a.091.091 0 01.1-.085.088.088 0 01.063.031.086.086 0 01.02.067c-.019.245-.037.487-.059.729a.09.09 0 01-.12.083zm-121.046-.237a.091.091 0 01-.091-.088l-.032-.729a.093.093 0 11.184 0l.03.729a.091.091 0 01-.085.1zm121.232-2.2a.093.093 0 01-.085-.1c.018-.242.035-.484.051-.729a.093.093 0 11.183 0c-.019.245-.035.487-.051.729a.093.093 0 01-.12.1zM385 337.716a.093.093 0 01-.09-.088l-.032-.729a.092.092 0 01.184-.008l.032.729a.093.093 0 01-.087.1zm121.491-2.193a.09.09 0 01-.062-.03.09.09 0 01-.023-.066c0-.242.029-.487.042-.732a.093.093 0 01.03-.062.091.091 0 01.066-.023.09.09 0 01.062.03.091.091 0 01.023.066l-.04.732a.093.093 0 01-.12.085zm-121.594-.242a.093.093 0 01-.09-.088l-.032-.732a.09.09 0 01.088-.093.093.093 0 01.1.085l.032.732a.093.093 0 01-.088.1zm121.722-2.193a.094.094 0 01-.088-.1l.032-.729a.1.1 0 01.1-.088.089.089 0 01.062.03.091.091 0 01.023.066c0 .242-.019.487-.032.729a.088.088 0 01-.036.072.091.091 0 01-.079.016zm-121.823-.242a.093.093 0 01-.093-.088l-.029-.732a.09.09 0 01.022-.066.089.089 0 01.062-.03.093.093 0 01.1.088l.032.732a.093.093 0 01-.088.1zm121.919-2.193a.093.093 0 01-.088-.1c0-.242.016-.487.021-.729a.093.093 0 11.183 0c0 .245 0 .487-.021.729a.094.094 0 01-.034.078.093.093 0 01-.083.018zm-122.023-.242a.093.093 0 01-.093-.088l-.029-.732a.091.091 0 11.181 0l.032.732a.094.094 0 01-.088.1zm122.087-2.2a.093.093 0 01-.091-.093v-.732a.091.091 0 01.091-.09.093.093 0 01.09.094v.732a.093.093 0 01-.112.09zm-122.191-.242a.088.088 0 01-.091-.085l-.032-.732a.093.093 0 01.088-.1.1.1 0 01.093.088l.032.732a.089.089 0 01-.024.066.088.088 0 01-.064.028zm122.223-2.2a.1.1 0 01-.09-.093v-.729a.09.09 0 01.091-.09.093.093 0 01.093.09v.732a.093.093 0 01-.115.09zm-122.327-.239a.091.091 0 01-.09-.088l-.032-.729a.093.093 0 01.088-.1.1.1 0 01.1.088l.029.732a.09.09 0 01-.088.093zm122.324-2.2a.091.091 0 01-.091-.091v-.729a.091.091 0 01.181 0v.732a.091.091 0 01-.09.09zm-122.42-.237a.09.09 0 01-.09-.088l-.032-.729a.092.092 0 01.184-.008l.029.729a.09.09 0 01-.085.1zm122.388-2.2a.09.09 0 01-.09-.088c0-.245 0-.487-.022-.732a.093.093 0 01.09-.093.09.09 0 01.091.088c0 .245 0 .487.019.732a.088.088 0 01-.024.065.089.089 0 01-.07.044zm-122.501-.225a.09.09 0 01-.09-.088l-.032-.729a.093.093 0 01.088-.1.1.1 0 01.1.088l.032.729a.093.093 0 01-.088.1zm122.419-2.2a.093.093 0 01-.093-.088c0-.242-.019-.487-.032-.729a.093.093 0 01.088-.1.09.09 0 01.066.022.089.089 0 01.03.063l.032.732a.093.093 0 01-.088.1zm-122.518-.237a.09.09 0 01-.091-.088l-.032-.729a.093.093 0 11.184 0l.032.729a.093.093 0 01-.088.1zm122.4-2.2a.091.091 0 01-.09-.085c-.016-.242-.029-.487-.045-.729a.093.093 0 01.085-.1.1.1 0 01.1.088c0 .242.029.487.042.729a.09.09 0 01-.085.1zm-122.5-.237a.09.09 0 01-.093-.087l-.029-.729a.091.091 0 01.023-.066.091.091 0 01.158.058l.032.729a.093.093 0 01-.088.1zm122.337-2.193a.091.091 0 01-.091-.085 55.218 55.218 0 00-.058-.729.093.093 0 01.184-.016l.056.732a.088.088 0 01-.082.1zm-122.438-.233a.093.093 0 01-.093-.088l-.029-.732a.091.091 0 11.181 0l.032.729a.093.093 0 01-.088.1zm122.233-2.188a.093.093 0 01-.091-.083l-.072-.726a.091.091 0 11.181-.019q.04.362.072.726a.093.093 0 01-.083.1zm-122.337-.247a.1.1 0 01-.093-.088l-.029-.732a.087.087 0 01.088-.093.086.086 0 01.094.085l.031.732a.093.093 0 01-.088.1zm122.082-2.177a.09.09 0 01-.09-.08l-.088-.726a.091.091 0 11.181-.021l.088.726a.09.09 0 01-.08.1zm-122.185-.266a.091.091 0 01-.09-.088l-.032-.732a.093.093 0 01.088-.1.1.1 0 01.1.088l.029.732a.093.093 0 01-.088.1zm1.562-.748a.093.093 0 01-.094-.041.1.1 0 010-.1.093.093 0 01.094-.041h.732a.088.088 0 01.093.091.093.093 0 01-.09.093h-.732zm2.438-.024a.1.1 0 01-.093-.09.093.093 0 01.09-.093h.732a.085.085 0 01.068.024.087.087 0 01.026.067.093.093 0 01-.09.093zm2.438-.027a.092.092 0 110-.183h.732a.085.085 0 01.093.09.09.09 0 01-.09.09h-.732zm2.435-.024a.093.093 0 010-.184h.732a.089.089 0 01.093.091.093.093 0 01-.09.093h-.732zm2.438-.027a.09.09 0 110-.181h.732a.082.082 0 01.09.091.088.088 0 01-.09.09h-.729zm2.438-.024a.09.09 0 01-.09-.09.094.094 0 01.09-.093h.732a.09.09 0 01.09.09.093.093 0 01-.09.093h-.729zm2.438-.026a.091.091 0 010-.181h.729a.09.09 0 01.09.09.093.093 0 01-.09.093h-.732zm2.438-.024a.093.093 0 010-.183h.729a.093.093 0 010 .183h-.732zm2.438-.027a.093.093 0 01-.093-.09.091.091 0 01.091-.09h.732a.091.091 0 01.09.09.093.093 0 01-.09.093h-.732zm2.438-.024a.093.093 0 010-.184h.732a.091.091 0 010 .181h-.732zm2.438-.024a.092.092 0 010-.184h.732a.1.1 0 01.093.091.093.093 0 01-.09.093zm2.435-.027a.09.09 0 110-.181h.732a.1.1 0 01.093.09.091.091 0 01-.09.09h-.732zm2.438-.024a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.732a.087.087 0 01.091.09.09.09 0 01-.091.093h-.729zm2.438-.026a.09.09 0 010-.181h.732a.085.085 0 01.065.026.088.088 0 01.026.065.091.091 0 01-.09.091h-.729zm2.438-.024a.09.09 0 01-.091-.09.093.093 0 01.09-.093h.729a.087.087 0 01.093.09.093.093 0 01-.091.093zm2.438-.026a.091.091 0 010-.181h.729a.087.087 0 01.068.024.085.085 0 01.026.067.093.093 0 01-.09.094h-.732zm2.438-.024a.093.093 0 110-.183h.732a.085.085 0 01.068.024.086.086 0 01.026.067.091.091 0 01-.09.09h-.732zm2.438-.024a.1.1 0 01-.093-.09.093.093 0 01.09-.093h.732a.086.086 0 01.068.023.084.084 0 01.025.067.093.093 0 01-.09.093zm2.438-.026a.092.092 0 010-.184h.732a.084.084 0 01.067.023.085.085 0 01.026.067.09.09 0 01-.09.09h-.732zm2.435-.024a.093.093 0 010-.183h.732a.089.089 0 01.093.09.093.093 0 01-.091.093h-.732zm2.438-.026a.091.091 0 010-.181h.732a.09.09 0 01.09.091.087.087 0 01-.026.065.088.088 0 01-.065.026h-.737zm2.438-.024a.091.091 0 01-.091-.091.093.093 0 01.091-.093h.731a.093.093 0 010 .184h-.729zm2.437-.026a.091.091 0 010-.181h.732a.09.09 0 01.09.09.093.093 0 01-.09.093h-.732zm2.438-.024a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.729a.093.093 0 010 .184h-.732zm2.437-.024a.092.092 0 010-.184h.73a.093.093 0 010 .184h-.732zm2.438-.027a.093.093 0 010-.184h.732a.09.09 0 01.093.09.091.091 0 01-.09.091h-.732zm2.438-.024a.093.093 0 010-.184h.732a.1.1 0 01.093.091.093.093 0 01-.09.093h-.732zm2.435-.027a.09.09 0 010-.181h.732a.1.1 0 01.093.09.09.09 0 01-.09.09h-.732zm2.438-.024a.093.093 0 010-.183h.732a.087.087 0 01.09.09.09.09 0 01-.09.093h-.729zm2.438-.026a.09.09 0 110-.181h.732a.084.084 0 01.065.026.086.086 0 01.026.064.093.093 0 01-.091.093h-.729zm2.438-.024a.09.09 0 01-.091-.09.093.093 0 01.091-.093h.732a.088.088 0 01.09.09.093.093 0 01-.09.093zm2.438-.026a.091.091 0 010-.181h.729a.085.085 0 01.068.024.087.087 0 01.026.066.094.094 0 01-.091.094h-.732zm2.438-.024a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.729a.082.082 0 01.093.09.09.09 0 01-.09.09h-.732zm2.438-.024a.1.1 0 01-.093-.09.093.093 0 01.091-.093h.732a.084.084 0 01.068.023.086.086 0 01.026.067.094.094 0 01-.09.093zm2.438-.026a.094.094 0 01-.094-.091.091.091 0 01.09-.09h.732a.081.081 0 01.068.023.079.079 0 01.025.068.09.09 0 01-.09.091zm2.437-.024a.093.093 0 01-.093-.143.094.094 0 01.093-.041h.732a.092.092 0 010 .184h-.732zm2.436-.026a.09.09 0 110-.181h.732a.09.09 0 01.09.091.088.088 0 01-.09.09h-.738zm2.438-.024a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.732a.092.092 0 01.065.156.09.09 0 01-.065.027h-.729zm2.438-.026a.091.091 0 010-.181h.732a.091.091 0 01.09.091.093.093 0 01-.09.093h-.729zm2.438-.024a.091.091 0 01-.09-.09.093.093 0 01.09-.093h.729a.091.091 0 110 .181h-.732zm2.438-.024a.09.09 0 01-.09-.09.09.09 0 01.09-.093h.729a.093.093 0 010 .184h-.732zm2.438-.027a.093.093 0 010-.183h.732a.1.1 0 01.093.09.091.091 0 01-.091.09h-.732zm2.438-.024a.092.092 0 110-.184h.732a.09.09 0 01.093.09.093.093 0 01-.09.093zm2.438-.027a.093.093 0 01-.093-.09.09.09 0 01.091-.09h.732a.1.1 0 01.093.09.09.09 0 01-.091.09zm2.435-.024a.093.093 0 010-.184h.732a.1.1 0 01.093.091.093.093 0 01-.09.093h-.732zm2.438-.026a.091.091 0 010-.181h.732a.088.088 0 01.065.026.087.087 0 01.025.065.093.093 0 01-.09.093h-.729zm2.438-.024a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.732a.087.087 0 01.065.026.089.089 0 01.026.065.094.094 0 01-.091.093h-.729zm2.438-.024a.093.093 0 010-.184h.732a.085.085 0 01.09.091.093.093 0 01-.09.093zm2.438-.027a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.729a.083.083 0 01.093.09.09.09 0 01-.09.09h-.732zm2.438-.024a.093.093 0 010-.183h.729a.085.085 0 01.093.09.093.093 0 01-.091.093z"
            fill="#fff"
          />
          <path
            data-name="Path 9403"
            d="M1540.88 1024.389l.266-3.279a2.52 2.52 0 011.895-1.49c3.164-.532 11.015-1.5 14.829 1.285l.6 3.8z"
            transform="translate(-1130.806 -747.827)"
            fill="#E9605A"
          />
          <path
            data-name="Path 9404"
            d="M1567.44 993.367a4.561 4.561 0 01-2.193.019 1.981 1.981 0 01-1.531-1.9l-.106-10.257 5.222-.056.106 10.251a1.99 1.99 0 01-1.498 1.943z"
            transform="translate(-1147.487 -720.054)"
            fill="url(#prefix__A)"
          />
          <path
            data-name="Path 9405"
            d="M1730.87 1022.436l.266-3.279a2.52 2.52 0 011.9-1.49c3.162-.532 11.013-1.506 14.826 1.283l.6 3.8z"
            transform="translate(-1270.234 -746.393)"
            fill="#E9605A"
          />
          <path
            data-name="Path 9406"
            d="M1757.41 988.453a4.561 4.561 0 01-2.193.021 1.986 1.986 0 01-1.533-1.884l-.114-11.337 5.219-.053.117 11.329a1.988 1.988 0 01-1.496 1.924z"
            transform="translate(-1286.893 -715.673)"
            fill="url(#prefix__C)"
          />
          <path
            data-name="Path 9407"
            d="M1554.075 943.281l56.121-2.435a2.7 2.7 0 002.563-2.249 22.8 22.8 0 00.1-7.116 6.478 6.478 0 00-6.334-5.418c-10.475-.141-37.136.141-51.773 6.1a5.139 5.139 0 00-3.063 3.593 12.431 12.431 0 00-.075 5.7 2.411 2.411 0 002.461 1.825z"
            transform="translate(-1138.468 -679.595)"
            fill="#FF928E"
          />
          <path
            data-name="Path 9408"
            d="M414.602 260.779a.248.248 0 01-.242-.218 13.275 13.275 0 01.293-4.232 4.674 4.674 0 013.154-3.271 61.8 61.8 0 0113.958-2.76.24.24 0 01.253.234.242.242 0 01-.234.266 61.4 61.4 0 00-13.839 2.739 4.186 4.186 0 00-2.821 2.927 12.877 12.877 0 00-.266 4.056.245.245 0 01-.216.266z"
            fill="#fff"
            opacity={0.51}
          />
          <path
            data-name="Path 9409"
            d="M1427.079 1032.925c18.137-.42 96.589-2.052 119.41.463a4.638 4.638 0 014.024 3.553c1.411 6.073 4.258 20.191 4.087 34.214a4.058 4.058 0 01-3.286 3.907l-51.922 10.379-18.48.192-55.549-10.448a4.341 4.341 0 01-3.537-3.992c-.431-7.049-1.166-23.592.633-34.264a4.79 4.79 0 014.62-4.004z"
            transform="translate(-1043.054 -757.369)"
            fill="url(#prefix__E)"
          />
          <path
            data-name="Path 9410"
            d="M438.242 323.877h-.016l-.718-.135a.091.091 0 01-.075-.107.093.093 0 01.107-.072l.718.136a.09.09 0 01.06.038.089.089 0 01.015.069.093.093 0 01-.091.071zm1.229 0a.09.09 0 01-.091-.09.094.094 0 01.091-.093h.732a.091.091 0 010 .181h-.729zm2.438-.024a.093.093 0 010-.184h.729a.1.1 0 01.093.09.093.093 0 01-.09.093zm2.438-.027a.09.09 0 01-.09-.09.088.088 0 01.09-.09h.729a.1.1 0 01.093.09.09.09 0 01-.09.09zm2.438-.024a.092.092 0 010-.184h.732a.1.1 0 01.093.091.093.093 0 01-.09.093zm2.438-.026a.093.093 0 01-.093-.09.09.09 0 01.09-.09h.732a.1.1 0 01.093.09.091.091 0 01-.09.09zm2.438-.024a.093.093 0 110-.184h.732a.1.1 0 01.093.091.093.093 0 01-.09.093h-.732zm2.435-.027a.091.091 0 010-.181h.732a.1.1 0 01.093.091.093.093 0 01-.091.093h-.732zm2.425-.149a.088.088 0 01-.088-.075.09.09 0 01.014-.068.091.091 0 01.058-.038l.716-.144a.093.093 0 11.037.181l-.719.141zm-20.673-.136h-.016l-.721-.136a.09.09 0 01-.058-.038.089.089 0 01-.014-.068.086.086 0 01.037-.059.089.089 0 01.069-.013l.719.133a.1.1 0 01.075.109.094.094 0 01-.091.048zm23.066-.341a.093.093 0 01-.019-.184l.716-.141a.091.091 0 01.109.072.093.093 0 01-.072.106l-.719.144zm-25.461-.112h-.019l-.719-.136a.093.093 0 01-.072-.106.09.09 0 01.037-.06.092.092 0 01.069-.015l.718.136a.091.091 0 01.072.107.087.087 0 01-.088.05zm27.85-.367a.091.091 0 01-.09-.074.092.092 0 01.014-.068.093.093 0 01.058-.038l.716-.144a.093.093 0 01.109.072.09.09 0 01-.072.109l-.718.141zm-30.245-.083h-.019l-.719-.133a.093.093 0 01-.072-.109.091.091 0 01.039-.058.089.089 0 01.068-.014l.719.136a.089.089 0 01.059.038.087.087 0 01.013.069.091.091 0 01-.088.048zm32.635-.394a.093.093 0 01-.019-.183l.719-.141a.091.091 0 01.034.178l-.716.144zm-35.033-.056h-.016l-.719-.136a.091.091 0 11.035-.178l.719.136a.09.09 0 01.072.106.09.09 0 01-.091.048zm37.423-.423a.091.091 0 01-.019-.181l.719-.144a.093.093 0 01.106.072.088.088 0 01-.072.107l-.716.144zm-39.818-.029h-.016l-.718-.136a.093.093 0 01-.035-.166.092.092 0 01.069-.015l.719.136a.093.093 0 01.072.107.091.091 0 01-.09.05zm42.208-.45a.093.093 0 01-.09-.072.1.1 0 01.072-.109l.719-.141a.088.088 0 01.106.072.09.09 0 01-.072.107l-.716.144zm-44.6 0h-.016l-.719-.133a.1.1 0 01-.074-.109.093.093 0 01.106-.072l.719.136a.091.091 0 11-.016.181zm-2.4-.45h-.016l-.718-.136a.091.091 0 11.032-.178l.718.136a.091.091 0 01.075.106.093.093 0 01-.091.048zm49.388-.026a.088.088 0 01-.088-.075.091.091 0 01.072-.106l.716-.144a.093.093 0 01.109.072.091.091 0 01-.072.107l-.719.144zm-51.783-.426h-.016l-.721-.136a.088.088 0 01-.058-.038.091.091 0 01.093-.14l.719.133a.092.092 0 01.074.106.09.09 0 01-.09.05zm54.173-.053a.088.088 0 01-.088-.072.091.091 0 01.072-.109l.716-.141a.093.093 0 01.109.069.1.1 0 01-.072.109l-.718.144zm-56.569-.4h-.018l-.719-.133a.093.093 0 01-.071-.106.09.09 0 01.106-.074l.719.136a.091.091 0 11-.016.181zm58.961-.08a.091.091 0 01-.09-.075.09.09 0 01.072-.106l.716-.144a.093.093 0 01.109.072.091.091 0 01-.072.107l-.719.144zm-61.356-.4h-.019l-.719-.136a.091.091 0 11.035-.178l.719.136a.088.088 0 01.072.106.09.09 0 01-.09.075zm63.746-.109a.09.09 0 01-.09-.072.093.093 0 01.072-.109l.718-.144a.093.093 0 01.107.072.092.092 0 01-.013.07.09.09 0 01-.059.039l-.716.144zm-66.144-.341h-.016l-.719-.136a.091.091 0 11.034-.178l.719.133a.093.093 0 01-.019.183zm68.534-.136a.091.091 0 01-.019-.181l.719-.144a.092.092 0 01.094.141.087.087 0 01-.06.037l-.716.144zm-70.929-.317h-.016l-.718-.136a.093.093 0 01-.074-.107.1.1 0 01.109-.074l.718.136a.093.093 0 01.072.106.088.088 0 01-.091.082zm73.319-.162a.088.088 0 01-.088-.072.093.093 0 01.069-.109l.718-.144a.093.093 0 01.035.181l-.716.144zm-75.714-.287h-.016l-.718-.136a.091.091 0 01-.06-.037.091.091 0 01.092-.141l.719.136a.091.091 0 01.074.106.093.093 0 01-.09.093zm78.1-.189a.091.091 0 11-.016-.181l.716-.144a.092.092 0 01.094.14.087.087 0 01-.057.039l-.719.144zm-80.5-.266h-.016l-.719-.135a.091.091 0 01-.06-.037.09.09 0 01-.015-.069.09.09 0 01.106-.072l.718.133a.1.1 0 01.075.109.093.093 0 01-.091.085zm82.889-.218a.088.088 0 01-.088-.072.091.091 0 01.072-.109l.716-.144a.093.093 0 11.037.181l-.719.144zm-85.284-.234h-.016l-.721-.135a.092.092 0 01.035-.181l.719.136a.093.093 0 01.075.107.09.09 0 01-.091.088zm87.677-.242a.094.094 0 01-.091-.075.089.089 0 01.072-.106l.716-.144a.091.091 0 01.037.178l-.719.144zm-90.072-.208h-.018l-.719-.133a.094.094 0 01-.072-.109.091.091 0 01.106-.072l.719.136a.088.088 0 01.072.107.09.09 0 01-.088.085zm92.461-.266a.091.091 0 01-.019-.181l.719-.144a.093.093 0 01.107.072.091.091 0 01-.072.109l-.716.144zm-94.856-.178h-.019l-.719-.136a.09.09 0 01-.072-.106.088.088 0 01.106-.072l.718.136a.087.087 0 01.059.037.089.089 0 01.013.069.091.091 0 01-.088.08zm97.246-.3a.1.1 0 01-.09-.075.09.09 0 01.071-.107l.719-.144a.091.091 0 11.035.178l-.716.144zm-99.644-.155h-.016l-.718-.136a.091.091 0 01-.072-.106.089.089 0 01.038-.06.09.09 0 01.069-.015l.719.135a.093.093 0 01.072.107.088.088 0 01-.09.083zm102.034-.325a.093.093 0 01-.09-.072.1.1 0 01.072-.109l.719-.144a.093.093 0 01.106.072.092.092 0 01-.013.07.09.09 0 01-.059.039l-.716.144zm-104.429-.125h-.016l-.719-.133a.093.093 0 01.035-.181l.719.136a.091.091 0 01.058.038.089.089 0 01.013.068.09.09 0 01-.09.08zm106.819-.351a.091.091 0 01-.088-.075.089.089 0 01.013-.069.087.087 0 01.059-.037l.716-.144a.088.088 0 01.068.013.089.089 0 01.038.059.09.09 0 01-.014.068.092.092 0 01-.058.038l-.716.144zm-109.214-.1h-.016l-.718-.136a.092.092 0 01-.06-.038.091.091 0 01-.014-.069.093.093 0 01.106-.072l.719.135a.093.093 0 01.06.038.091.091 0 01.015.069.093.093 0 01-.091.08zm111.6-.381a.088.088 0 01-.088-.072.092.092 0 01.013-.07.09.09 0 01.059-.039l.716-.144a.093.093 0 01.037.181l-.719.143zm-114-.072h-.016l-.719-.135a.093.093 0 01-.074-.107.089.089 0 01.038-.058.091.091 0 01.068-.014l.719.133a.093.093 0 01.074.106.09.09 0 01-.09.083zm116.392-.4a.093.093 0 01-.091-.075.088.088 0 01.072-.106l.716-.144a.091.091 0 01.07.013.09.09 0 01.039.059.093.093 0 01-.072.106l-.719.144zm-118.787-.045h-.019l-.719-.133a.093.093 0 01-.034-.166.091.091 0 01.069-.015l.719.136a.089.089 0 01.06.037.092.092 0 01.015.069.094.094 0 01-.091.08zm121.177-.434a.091.091 0 01-.019-.181l.266-.053v-.312a.09.09 0 01.09-.09.093.093 0 01.093.093v.455l-.412.083zm-123.484-.088a.091.091 0 01-.09-.085l-.045-.732a.093.093 0 01.088-.1.09.09 0 01.065.023.091.091 0 01.03.062l.042.732a.089.089 0 01-.023.065.091.091 0 01-.062.03zm123.83-2.068a.093.093 0 01-.093-.091v-.732a.09.09 0 11.181 0v.732a.093.093 0 01-.09.093zm-123.966-.368a.09.09 0 01-.093-.085l-.037-.732a.093.093 0 01.088-.1.1.1 0 01.1.088l.037.729a.093.093 0 01-.088.1zm123.9-2.07a.091.091 0 01-.091-.088c0-.242-.019-.487-.029-.729a.092.092 0 11.183-.008c0 .242.019.487.027.732a.091.091 0 01-.088.093zm-124.017-.365a.091.091 0 01-.091-.088l-.032-.729a.093.093 0 01.088-.1.089.089 0 01.068.023.088.088 0 01.028.065l.029.729a.09.09 0 01-.023.066.091.091 0 01-.063.03zm123.91-2.068a.09.09 0 01-.093-.085c0-.242-.027-.487-.042-.726a.093.093 0 01.085-.1.09.09 0 01.1.085c.016.242.032.484.045.729a.09.09 0 01-.085.1zm-124.017-.367a.093.093 0 01-.09-.09l-.024-.729a.093.093 0 11.184 0l.024.732a.094.094 0 01-.088.1zm123.841-2.062a.094.094 0 01-.09-.085 59.611 59.611 0 00-.058-.729.093.093 0 01.085-.1.1.1 0 01.1.085c.018.242.04.484.058.729a.093.093 0 01-.085.1zm-123.912-.375a.093.093 0 01-.093-.09c0-.242 0-.484-.016-.732a.091.091 0 01.088-.093.09.09 0 01.09.09c0 .245 0 .49.019.732a.09.09 0 01-.077.095zm123.7-2.055a.093.093 0 01-.09-.082l-.072-.729a.088.088 0 01.021-.066.091.091 0 01.062-.032.094.094 0 01.1.083c.024.242.048.484.069.727a.092.092 0 01-.082.1zm-123.75-.383a.093.093 0 01-.093-.09v-.732a.093.093 0 01.09-.093.085.085 0 01.067.024.086.086 0 01.026.067v.732a.093.093 0 01-.074.095zm123.505-2.041a.091.091 0 01-.09-.083l-.085-.726a.093.093 0 01.184-.021c.026.242.056.484.082.726a.093.093 0 01-.08.1zm-123.532-.4a.091.091 0 01-.09-.091v-.732a.094.094 0 01.093-.091.091.091 0 01.09.091v.729a.093.093 0 01-.09.093zm123.239-2.025a.09.09 0 01-.09-.08l-.094-.726a.088.088 0 01.077-.1.1.1 0 01.1.077c.032.242.064.484.093.727a.088.088 0 01-.077.1zm-123.239-.413a.091.091 0 01-.09-.091v-.732a.09.09 0 01.027-.066.088.088 0 01.066-.025.093.093 0 01.09.093v.729a.093.093 0 01-.028.072.094.094 0 01-.073.026zm122.909-2a.09.09 0 01-.088-.08 66.628 66.628 0 01-.106-.724.093.093 0 01.077-.1.1.1 0 01.1.077c.035.24.069.482.106.727a.093.093 0 01-.08.1zm-122.877-.434a.088.088 0 01-.088-.093l.016-.732a.09.09 0 01.093-.088.087.087 0 01.064.027.089.089 0 01.024.065l-.016.732a.09.09 0 01-.027.073.089.089 0 01-.074.023zm122.513-1.977a.093.093 0 01-.091-.077c-.037-.245-.077-.484-.114-.724a.091.091 0 01.075-.1.093.093 0 01.1.075c.04.239.08.481.117.724a.09.09 0 01-.074.1zm-122.446-.46a.088.088 0 01-.064-.027.087.087 0 01-.024-.065c0-.245.019-.49.027-.732a.092.092 0 01.183.008c0 .242-.019.487-.029.729a.088.088 0 01-.1.1zm122.047-1.945a.091.091 0 01-.09-.077q-.064-.365-.128-.718a.091.091 0 01.015-.069.089.089 0 01.06-.037.088.088 0 01.069.015.09.09 0 01.037.06l.128.719a.093.093 0 01-.074.106zm-121.938-.492a.093.093 0 01-.088-.1c0-.245.027-.487.043-.729a.1.1 0 01.1-.088.093.093 0 01.085.1l-.04.729a.091.091 0 01-.03.071.089.089 0 01-.074.022zm121.5-1.908a.09.09 0 01-.088-.074c-.045-.242-.093-.482-.138-.719a.09.09 0 01.074-.107.092.092 0 01.068.014.09.09 0 01.038.058q.069.354.136.719a.093.093 0 01-.014.068.092.092 0 01-.058.038zm-121.355-.532a.093.093 0 01-.085-.1l.059-.729a.091.091 0 01.032-.062.09.09 0 01.066-.021.093.093 0 01.085.1c-.021.24-.04.484-.058.726a.094.094 0 01-.1.091zm120.876-1.863a.091.091 0 01-.088-.074l-.149-.716a.093.093 0 01.181-.037l.146.716a.091.091 0 01-.013.07.092.092 0 01-.059.039zm-120.66-.559a.093.093 0 01-.08-.1c.024-.245.051-.487.08-.729a.089.089 0 01.034-.061.09.09 0 01.067-.019.093.093 0 01.08.1l-.08.727a.093.093 0 01-.1.093zm120.157-1.828a.088.088 0 01-.088-.072l-.16-.716a.1.1 0 01.069-.109.093.093 0 01.109.069c.051.229.1.468.159.716a.089.089 0 01-.012.07.091.091 0 01-.059.039zm-119.862-.593h-.013a.1.1 0 01-.08-.1c.035-.245.072-.484.109-.724a.092.092 0 01.036-.061.092.092 0 01.145.087c-.037.24-.074.479-.109.724a.088.088 0 01-.085.088zm118.832-1.267l-.726-.072a.091.091 0 01-.062-.032.089.089 0 01-.021-.066.093.093 0 01.1-.083l.729.072a.1.1 0 01-.016.192zm-2.43-.221l-.74-.051a.093.093 0 01-.085-.1.09.09 0 01.1-.083l.729.056a.093.093 0 01.085.1.1.1 0 01-.085.088zm-2.43-.178l-.729-.045a.092.092 0 01-.063-.03.091.091 0 01-.023-.066.093.093 0 01.1-.088l.729.048a.092.092 0 01.063.03.091.091 0 01.023.066.088.088 0 01-.1.1zm-112.86 0a.093.093 0 010-.184l.732-.016a.093.093 0 01.093.09.091.091 0 01-.088.093l-.732.016zm2.438-.056a.09.09 0 01-.091-.088.093.093 0 01.091-.093l.729-.016a.085.085 0 01.1.088.093.093 0 01-.09.093l-.732.016zm2.44-.051a.092.092 0 110-.183l.732-.016a.1.1 0 01.093.091.093.093 0 01-.09.093zm105.547-.037l-.729-.04a.09.09 0 01-.062-.03.091.091 0 01-.023-.066.089.089 0 01.03-.063.088.088 0 01.066-.022l.729.037a.093.093 0 01.064.031.1.1 0 01.024.068.094.094 0 01-.1.09zm-103.109-.016a.09.09 0 01-.09-.088.089.089 0 01.024-.066.087.087 0 01.064-.027l.732-.016a.093.093 0 110 .184h-.729zm2.438-.048a.09.09 0 01-.091-.09.086.086 0 01.024-.066.087.087 0 01.064-.028l.732-.016a.092.092 0 010 .184zm2.437-.048a.093.093 0 010-.184l.729-.013a.093.093 0 01.093.088.087.087 0 01-.024.066.086.086 0 01-.064.028l-.732.016zm95.807 0l-.729-.032a.093.093 0 01-.088-.1.091.091 0 01.1-.088l.729.035a.094.094 0 01.088.1.091.091 0 01-.1.085zm-93.364-.037a.091.091 0 01-.091-.091.093.093 0 01.091-.093h.732a.093.093 0 01.09.09.087.087 0 01-.023.066.089.089 0 01-.064.028l-.732.013zm2.438-.045a.091.091 0 01-.091-.091.093.093 0 01.091-.093h.731a.092.092 0 110 .184h-.732zm88.488-.019l-.729-.03a.1.1 0 01-.091-.093.1.1 0 01.1-.091l.732.029a.093.093 0 010 .184zm-86.047-.024a.093.093 0 010-.183l.732-.013a.1.1 0 01.093.09.093.093 0 01-.091.093h-.732zm2.438-.042a.093.093 0 110-.184h.732a.09.09 0 110 .181h-.732zm81.169-.024l-.732-.024a.087.087 0 01-.088-.093.086.086 0 01.028-.064.088.088 0 01.065-.024l.732.024a.087.087 0 01.088.093.09.09 0 01-.09.088zm-78.737-.016a.092.092 0 010-.184h.732a.088.088 0 01.066.025.085.085 0 01.026.066.093.093 0 01-.09.093zm2.438-.04a.093.093 0 01-.094-.041.092.092 0 010-.1.093.093 0 01.094-.041h.732a.09.09 0 01.093.091.093.093 0 01-.09.093h-.732zm73.861-.019l-.732-.021a.09.09 0 01-.088-.093.092.092 0 01.093-.09l.729.021a.093.093 0 010 .184zm-71.424-.019a.09.09 0 01-.09-.09.088.088 0 01.088-.093h.732a.092.092 0 110 .184zm2.438-.037a.091.091 0 01-.09-.088.088.088 0 01.088-.093h.732a.1.1 0 01.093.09.091.091 0 01-.09.091zm66.551 0l-.732-.019a.088.088 0 01-.064-.027.087.087 0 01-.024-.066.09.09 0 01.093-.088l.732.016a.087.087 0 110 .173zm-64.114-.022a.09.09 0 01-.09-.09.09.09 0 01.09-.093h.729a.09.09 0 01.09.09.093.093 0 01-.09.093h-.712zm2.438-.034a.091.091 0 110-.181h.729a.1.1 0 01.093.09.089.089 0 01-.026.066.09.09 0 01-.065.028h-.729zm59.238 0l-.729-.016a.092.092 0 110-.183l.732.016a.087.087 0 110 .173zm-56.8-.029a.09.09 0 01-.091-.09.093.093 0 01.091-.093h.732a.09.09 0 010 .181h-.729zm54.362-.021l-.732-.013a.094.094 0 01-.091-.093.087.087 0 01.028-.064.089.089 0 01.066-.024h.732a.092.092 0 010 .184zm-51.925 0a.093.093 0 010-.184h.732a.088.088 0 01.093.09.093.093 0 01-.09.093h-.732zm2.438-.027a.093.093 0 010-.183h.732a.1.1 0 01.09.09.093.093 0 01-.09.093h-.729zm47.052 0h-.732a.084.084 0 01-.064-.026.086.086 0 01-.024-.065.091.091 0 01.09-.091h.732a.093.093 0 010 .184zm-44.611-.021a.093.093 0 01-.093-.091.09.09 0 01.09-.09h.735a.085.085 0 01.093.09.091.091 0 01-.09.091zm42.173-.016h-.732a.089.089 0 01-.064-.027.088.088 0 01-.024-.066.09.09 0 01.09-.091h.732a.093.093 0 01.091.093.091.091 0 01-.091.067zm-39.736 0a.091.091 0 010-.181h.734a.1.1 0 01.091.09.093.093 0 01-.091.093h-.732zm2.44-.019a.093.093 0 010-.184h.732a.091.091 0 01.09.091.09.09 0 01-.09.09h-.732zm34.863 0h-.729a.088.088 0 01-.091-.09.09.09 0 01.091-.091h.732a.091.091 0 010 .181zm-32.42-.019a.09.09 0 010-.181h.71a.1.1 0 01.1.09.083.083 0 01-.02.063.081.081 0 01-.059.028zm29.982 0h-.732a.093.093 0 01-.09-.093.085.085 0 01.09-.09h.732a.09.09 0 110 .181zm-27.526 0l-.019-.09.019-.093h.713a.09.09 0 110 .181zm25.088 0h-.732a.093.093 0 010-.183h.732a.093.093 0 01.091.093.09.09 0 01-.093.032zm-22.65 0l-.019-.093.019-.09h.713a.09.09 0 110 .181zm20.226 0h-.732a.093.093 0 01-.091-.093.09.09 0 01.091-.09h.732a.093.093 0 01.091.093.091.091 0 01-.107.016zm-17.793 0a.09.09 0 110-.181h.729a.093.093 0 01.093.093.091.091 0 01-.091.09zm15.356 0h-.732a.09.09 0 01-.09-.09.093.093 0 01.09-.093h.732a.093.093 0 01.09.093.09.09 0 01-.106.005zm-12.907 0v-.183h.719a.092.092 0 110 .183zm2.435 0v-.181h.724a.093.093 0 01.093.09.092.092 0 01-.093.093zm8.035 0h-.732a.093.093 0 01-.09-.093.09.09 0 01.09-.09h.732a.09.09 0 110 .181zm-5.6 0a.093.093 0 110-.183h.729a.093.093 0 110 .183zm3.167 0h-.732a.093.093 0 01-.09-.093.09.09 0 01.09-.09h.716a.093.093 0 110 .183z"
            fill="#fff"
          />
          <path
            data-name="Path 9411"
            d="M1646.515 1196l-16.191.168a4.184 4.184 0 01-4.2-3.633l-2.03-15.56a4.175 4.175 0 014.112-4.708l19.448-.2a4.178 4.178 0 014.221 4.5l-1.23 15.595a4.178 4.178 0 01-4.133 3.843z"
            transform="translate(-1191.851 -860.149)"
            fill="#E9605A"
          />
          <path
            data-name="Path 9412"
            d="M1653.713 1201.057l-12.325.127a3.193 3.193 0 01-3.193-2.765l-1.546-11.843a3.178 3.178 0 013.13-3.582l14.8-.154a3.194 3.194 0 013.212 3.422l-.934 11.87a3.193 3.193 0 01-3.144 2.925z"
            transform="translate(-1201.069 -868.054)"
            fill="url(#prefix__G)"
          />
          <path
            data-name="Rectangle 1272"
            fill="#7d97f4"
            d="M371.342 100.293l27.543-71.38 33.283 12.843-27.543 71.38z"
          />
          <path
            data-name="Path 9413"
            d="M404.368 35.552l19.044 7.348a3.212 3.212 0 002.009 4.016c.056.021.184.069.186.066l-22.23 57.617-.181-.077a3.164 3.164 0 00-4.167 1.613.175.175 0 01-.029.045l-18.629-7.186c1.014-2.627-.636-3.545-2.334-4.2-.053-.021-.072 0-.075 0l22.233-57.617.061.032a3.131 3.131 0 004.112-1.657z"
            fill="#fff"
            opacity={0.5}
          />
          <circle
            data-name="Ellipse 421"
            cx={11.223}
            cy={11.223}
            r={11.223}
            transform="rotate(-51.37 268.496 -364.819)"
            fill="url(#prefix__f)"
          />
          <path
            data-name="Path 9414"
            d="M408.318 74.729l-1.107-.426a9.676 9.676 0 01-1.863 2.845.687.687 0 01-.894.064l-.921-.681a.692.692 0 01-.085-1.038 8.037 8.037 0 001.711-2.635c.428-1.112.372-2.086-.4-2.4-.7-.266-1.357.21-2.369 1.6-1.453 1.972-3.026 3.194-4.966 2.435-1.751-.676-2.594-2.475-2.1-4.836l-1.107-.426a.692.692 0 01-.394-.894l.25-.652a.692.692 0 01.895-.4l.992.383a8.852 8.852 0 011.395-2.291.687.687 0 01.929-.1l.855.625a.692.692 0 01.106 1.017 7.217 7.217 0 00-1.386 2.267c-.508 1.331-.109 1.908.38 2.1.6.232 1.331-.4 2.512-1.911 1.682-2.166 3.09-2.789 4.918-2.087 1.677.649 2.7 2.472 2.151 5.03l1.24.479a.692.692 0 01.4.894l-.25.649a.692.692 0 01-.892.389z"
            fill="#fff"
          />
          <path
            data-name="Path 9415"
            d="M380.372 101.818a.148.148 0 01-.066-.013l-6.241-2.4a.186.186 0 01-.1-.239l6.8-17.626a.184.184 0 01.344.133l-6.736 17.455 6.07 2.342a.181.181 0 01.1.237.184.184 0 01-.171.111z"
            fill="#fff"
          />
          <path
            data-name="Path 9416"
            d="M422.773 60.696a.2.2 0 01-.066-.013.181.181 0 01-.1-.237l6.653-17.237-6.512-2.5a.184.184 0 11.133-.343l6.677 2.579a.181.181 0 01.106.237l-6.717 17.408a.183.183 0 01-.174.106z"
            fill="#fff"
          />
          <path
            data-name="Rectangle 1273"
            fill="#91b3fa"
            d="M369.644 96.87l27.543-71.38 33.502 12.927-27.544 71.38z"
          />
          <path
            data-name="Path 9417"
            d="M402.736 32.156l19.044 7.348a3.276 3.276 0 002.089 4.035 1.874 1.874 0 01.267.088l-22.233 57.617c-.218-.088-.2-.085-.266-.106a3.215 3.215 0 00-4.21 1.6c0 .024-.072.043-.072.043l-18.613-7.186c1.011-2.627-.665-3.569-2.363-4.223a.265.265 0 00-.1-.019l22.23-57.617a.35.35 0 00.093.051 3.142 3.142 0 004.134-1.631z"
            fill="#bdd0fb"
          />
          <circle
            data-name="Ellipse 422"
            cx={11.223}
            cy={11.223}
            r={11.223}
            transform="rotate(-32 303.833 -638.497)"
            fill="url(#prefix__H)"
          />
          <path
            data-name="Path 9418"
            d="M406.697 71.32l-1.107-.428a9.7 9.7 0 01-1.863 2.848.681.681 0 01-.891.061l-.923-.679a.692.692 0 01-.085-1.038 8.019 8.019 0 001.711-2.635c.428-1.112.373-2.086-.4-2.4-.7-.266-1.36.21-2.371 1.6-1.453 1.972-3.023 3.194-4.966 2.435-1.751-.676-2.595-2.475-2.095-4.836l-1.107-.428a.69.69 0 01-.4-.894l.25-.649a.692.692 0 01.894-.4l1 .383a8.806 8.806 0 011.392-2.291.684.684 0 01.929-.1l.854.625a.689.689 0 01.106 1.017 7.27 7.27 0 00-1.371 2.246c-.508 1.331-.106 1.908.383 2.1.6.231 1.331-.4 2.512-1.911 1.679-2.166 3.09-2.792 4.918-2.086 1.677.647 2.7 2.472 2.151 5.03l1.237.479a.689.689 0 01.4.894l-.25.649a.692.692 0 01-.9.407z"
            fill="#fff"
          />
          <path
            data-name="Path 9419"
            d="M378.969 98.261a.185.185 0 01-.067 0l-6.459-2.494a.183.183 0 01-.107-.237l6.717-17.408a.184.184 0 01.344.133l-6.653 17.237 6.289 2.424a.183.183 0 01.1.237.18.18 0 01-.164.108z"
            fill="#fff"
            opacity={0.72}
          />
          <path
            data-name="Path 9420"
            d="M421.079 57.276a.188.188 0 01-.067 0 .184.184 0 01-.106-.237l6.653-17.235-6.289-2.427a.184.184 0 11.133-.343l6.459 2.494a.181.181 0 01.107.237l-6.717 17.408a.187.187 0 01-.173.1z"
            fill="#fff"
          />
          <path
            data-name="Rectangle 1274"
            fill="#7d97f4"
            d="M360.906 83.274l47.785-59.752 28.044 22.427L388.95 105.7z"
          />
          <path
            data-name="Path 9421"
            d="M1429.2 118.64l15.941 12.75a3.276 3.276 0 00.75 4.482c.046.035.016.019.2.165l-38.57 48.231c-.181-.149-.155-.13-.2-.168a3.173 3.173 0 00-4.476.266c-.016.019-.064 0-.064 0l-15.584-12.46c1.759-2.2.418-3.6-1-4.734a.252.252 0 00-.117-.051l38.568-48.233.1.075a3.183 3.183 0 004.452-.323z"
            transform="translate(-1017.203 -87.069)"
            fill="#E9EFFD"
          />
          <circle
            data-name="Ellipse 423"
            cx={11.223}
            cy={11.223}
            r={11.223}
            transform="rotate(-10.2 503.641 -2133.155)"
            fill="#7d97f4"
          />
          <path
            data-name="Path 9422"
            d="M403.945 70.131l-.926-.743a9.665 9.665 0 01-2.646 2.15.686.686 0 01-.87-.21l-.673-.926a.689.689 0 01.232-1.014 8.075 8.075 0 002.427-2c.743-.929.982-1.863.336-2.4-.583-.468-1.36-.208-2.741.8-1.98 1.442-3.843 2.129-5.469.825-1.467-1.174-1.727-3.14-.532-5.243l-.926-.74a.692.692 0 01-.109-.971l.437-.546a.692.692 0 01.971-.109l.833.665a8.866 8.866 0 012.018-1.764.689.689 0 01.918.184l.625.854a.692.692 0 01-.2 1 7.133 7.133 0 00-1.982 1.727c-.884 1.1-.679 1.786-.266 2.113.505.4 1.381.019 2.97-1.064 2.257-1.557 3.79-1.727 5.322-.506 1.405 1.123 1.834 3.172.532 5.445l1.038.828a.7.7 0 01.109.974l-.436.532a.69.69 0 01-.985.13z"
            fill="#fff"
          />
          <path
            data-name="Path 9423"
            d="M369.293 87.607a.175.175 0 01-.114-.04l-5.408-4.325a.184.184 0 01-.072-.127.182.182 0 01.043-.139l11.8-14.754a.188.188 0 11.293.237l-11.683 14.613 5.256 4.215a.184.184 0 01.027.266.178.178 0 01-.142.054z"
            fill="#fff"
            opacity={0.72}
          />
          <path
            data-name="Path 9424"
            d="M421.938 61.043a.186.186 0 01-.144-.309l11.54-14.43-5.264-4.21a.184.184 0 01-.029-.266.189.189 0 01.266-.029l5.408 4.325a.19.19 0 01.067.122.176.176 0 01-.04.136l-11.659 14.592a.186.186 0 01-.145.069z"
            fill="#fff"
            opacity={0.72}
          />
          <path
            data-name="Path 9425"
            d="M387.219 80.584a3.18 3.18 0 11-4.468.5 3.18 3.18 0 014.468-.5z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 9426"
            d="M417.092 43.23a3.18 3.18 0 11-4.469.5 3.18 3.18 0 014.469-.5z"
            fill="#7d97f4"
          />
          <circle
            data-name="Ellipse 424"
            cx={9.565}
            cy={9.565}
            r={9.565}
            transform="rotate(-73.18 220.72 -157.439)"
            fill="url(#prefix__I)"
          />
          <circle
            data-name="Ellipse 425"
            cx={9.245}
            cy={9.245}
            r={9.245}
            transform="rotate(-27.13 337.912 -591.766)"
            fill="url(#prefix__J)"
          />
          <path
            data-name="Path 9427"
            d="M311.196 91.596a.324.324 0 01-.144 0 .312.312 0 01-.24-.367 8.806 8.806 0 016.35-6.762 9.173 9.173 0 011.578-.28.31.31 0 11.051.617 8.25 8.25 0 00-7.375 6.549.306.306 0 01-.22.243z"
            fill="#fff"
            opacity={0.69}
          />
          <circle
            data-name="Ellipse 426"
            cx={7.824}
            cy={7.824}
            r={7.824}
            transform="rotate(-71.35 223.2 -166.74)"
            fill="#fff"
            opacity={0.69}
          />
          <path
            data-name="Path 9428"
            d="M1191.671 340.871l-.224-.822a6.946 6.946 0 01-2.441.128.5.5 0 01-.415-.492v-.822a.5.5 0 01.567-.49 5.712 5.712 0 002.249-.128c.825-.224 1.365-.671 1.211-1.245-.141-.516-.7-.695-1.929-.692-1.759 0-3.127-.4-3.518-1.839-.351-1.3.33-2.549 1.908-3.263l-.224-.822a.5.5 0 01.349-.609l.484-.13a.5.5 0 01.607.349l.2.737a6.387 6.387 0 011.916-.168.5.5 0 01.452.5v.761a.492.492 0 01-.532.492 5.164 5.164 0 00-1.879.162c-.979.266-1.149.745-1.064 1.11.123.447.8.6 2.172.641 1.964.053 2.928.6 3.292 1.959.338 1.245-.266 2.613-2 3.38l.25.918a.5.5 0 01-.349.609l-.482.13a.5.5 0 01-.6-.354z"
            transform="translate(-871.163 -241.905)"
            fill="#FF928E"
          />
          <circle
            data-name="Ellipse 427"
            cx={16.649}
            cy={16.649}
            r={16.649}
            transform="rotate(-45 250.073 -347.89)"
            fill="url(#prefix__L)"
          />
          <circle
            data-name="Ellipse 428"
            cx={16.096}
            cy={16.096}
            r={16.096}
            transform="rotate(-7.5 628.418 -2446.603)"
            fill="#FF928E"
          />
          <path
            data-name="Path 9429"
            d="M328.306 72.256a.326.326 0 01-.144 0 .309.309 0 01-.239-.365 15.1 15.1 0 0110.89-11.6 15.39 15.39 0 012.7-.479.31.31 0 01.053.617 14.563 14.563 0 00-13.04 11.585.314.314 0 01-.22.242z"
            fill="#fff"
            opacity={0.69}
          />
          <circle
            data-name="Ellipse 429"
            cx={13.623}
            cy={13.623}
            r={13.623}
            transform="rotate(-45 252.723 -353.45)"
            fill="#fff"
            opacity={0.69}
          />
          <path
            data-name="Path 9430"
            d="M1272.7 266.574l-.386-1.429a12.157 12.157 0 01-4.258.218.86.86 0 01-.724-.854v-1.432a.862.862 0 01.985-.852 10.027 10.027 0 003.917-.226c1.434-.389 2.374-1.166 2.105-2.164-.245-.9-1.219-1.211-3.361-1.206-3.058 0-5.44-.695-6.121-3.194-.612-2.262.572-4.442 3.322-5.682l-.389-1.432a.862.862 0 01.607-1.065l.841-.226a.862.862 0 011.064.607l.349 1.283a10.991 10.991 0 013.335-.29.857.857 0 01.8.86v1.331a.862.862 0 01-.945.86 8.984 8.984 0 00-3.273.279c-1.7.463-2 1.3-1.828 1.935.213.777 1.381 1.035 3.779 1.118 3.423.09 5.094 1.049 5.735 3.409.588 2.166-.49 4.551-3.476 5.881l.437 1.6a.868.868 0 01-.609 1.065l-.839.226a.865.865 0 01-1.064-.617z"
            transform="translate(-928.124 -181.269)"
            fill="#FF928E"
          />
          <circle
            data-name="Ellipse 430"
            cx={17.131}
            cy={17.131}
            r={17.131}
            transform="rotate(-6.58 979.11 -2951.141)"
            fill="url(#prefix__O)"
          />
          <circle
            data-name="Ellipse 431"
            cx={16.561}
            cy={16.561}
            r={16.561}
            transform="rotate(-19.58 454.529 -943.423)"
            fill="url(#prefix__P)"
          />
          <path
            data-name="Path 9431"
            d="M348.699 105.052a.283.283 0 01-.141 0 .311.311 0 01-.242-.365 15.534 15.534 0 0111.2-11.928 15.785 15.785 0 012.781-.492.309.309 0 11.053.615 15.275 15.275 0 00-2.661.474 14.916 14.916 0 00-10.757 11.444.309.309 0 01-.233.252z"
            fill="#fff"
            opacity={0.69}
          />
          <circle
            data-name="Ellipse 432"
            cx={14.017}
            cy={14.017}
            r={14.017}
            transform="rotate(-86.26 239.248 -125.791)"
            fill="#fff"
            opacity={0.69}
          />
          <path
            data-name="Path 9432"
            d="M1350.488 389.671l-.4-1.472a12.487 12.487 0 01-4.373.226.884.884 0 01-.743-.878v-1.474a.887.887 0 011.011-.876 10.356 10.356 0 004.032-.232c1.477-.4 2.443-1.2 2.164-2.23-.25-.926-1.25-1.245-3.46-1.24-3.148 0-5.589-.713-6.3-3.292-.631-2.331.588-4.569 3.415-5.855l-.4-1.474a.886.886 0 01.625-1.089l.865-.234a.886.886 0 011.091.623l.359 1.331a11.423 11.423 0 013.431-.3.886.886 0 01.814.886v1.36a.886.886 0 01-.972.886 9.178 9.178 0 00-3.369.287c-1.754.476-2.057 1.331-1.881 1.988.218.8 1.418 1.065 3.888 1.15 3.521.1 5.243 1.08 5.9 3.51.6 2.23-.5 4.681-3.574 6.052l.447 1.647a.889.889 0 01-.625 1.091l-.865.234a.892.892 0 01-1.08-.625z"
            transform="translate(-985.044 -271.183)"
            fill="url(#prefix__Q)"
          />
          <circle
            data-name="Ellipse 433"
            cx={12.553}
            cy={12.553}
            r={12.553}
            transform="rotate(-3.35 1341.352 -6214.418)"
            fill="url(#prefix__R)"
          />
          <circle
            data-name="Ellipse 434"
            cx={12.136}
            cy={12.136}
            r={12.136}
            transform="rotate(-18.7 400.03 -1067.32)"
            fill="url(#prefix__S)"
          />
          <path
            data-name="Path 9433"
            d="M367.808 77.598a.327.327 0 01-.144 0 .309.309 0 01-.242-.365 11.539 11.539 0 0110.32-9.166.31.31 0 11.05.617 11.019 11.019 0 00-1.943.343 10.848 10.848 0 00-7.821 8.33.309.309 0 01-.221.24z"
            fill="#fff"
            opacity={0.69}
          />
          <circle
            data-name="Ellipse 435"
            cx={10.27}
            cy={10.27}
            r={10.27}
            transform="rotate(-38.62 293.862 -481.312)"
            fill="#fff"
            opacity={0.69}
          />
          <path
            data-name="Path 9434"
            d="M1411.559 287.614l-.29-1.065a9.122 9.122 0 01-3.193.165.647.647 0 01-.532-.644v-1.078a.655.655 0 01.743-.644 7.512 7.512 0 002.954-.17c1.083-.293 1.791-.878 1.6-1.631-.184-.679-.919-.913-2.531-.91-2.307 0-4.1-.532-4.615-2.411-.463-1.709.431-3.348 2.5-4.285l-.293-1.078a.655.655 0 01.458-.8l.634-.17a.646.646 0 01.8.458l.266.969a8.274 8.274 0 012.515-.221.646.646 0 01.6.649v1a.649.649 0 01-.713.647 6.82 6.82 0 00-2.467.21c-1.285.349-1.509.982-1.379 1.458.16.588 1.041.782 2.85.844 2.578.066 3.84.8 4.322 2.571.445 1.631-.37 3.43-2.619 4.434l.328 1.206a.655.655 0 01-.458.8l-.633.17a.652.652 0 01-.838-.471z"
            transform="translate(-1031.507 -200.255)"
            fill="url(#prefix__T)"
          />
          <path
            data-name="Path 9435"
            d="M911.687 978.282c-22.525 12.811-41.327 12.013-62.591.838a3.992 3.992 0 01-2.129-3.726l.043-.9a3.992 3.992 0 015.49-3.5c18.464 7.524 32.351 11.651 55.472.242a3.992 3.992 0 015.74 3.313 3.992 3.992 0 01-2.025 3.737z"
            transform="translate(-621.56 -712.368)"
            fill="url(#prefix__U)"
          />
          <path
            data-name="Path 9436"
            d="M1046.818 978.889l12.434-17.62a.868.868 0 00-.6-1.363l-20.6-2.52a1.009 1.009 0 00-1.064 1.387 44.411 44.411 0 018.311 19.96.867.867 0 001.519.157z"
            transform="translate(-760.957 -702.593)"
            fill="url(#prefix__V)"
          />
          <path
            data-name="Path 9437"
            d="M922.708 405.166c22.677-14.006 42.048-13.887 64.308-3.194a4.109 4.109 0 012.337 3.752v.926a4.1 4.1 0 01-5.511 3.808c-19.26-7.047-33.687-10.773-57.029 1.818a4.1 4.1 0 01-6.022-3.194 4.112 4.112 0 011.917-3.916z"
            transform="translate(-675.723 -289.347)"
            fill="url(#prefix__W)"
          />
          <path
            data-name="Path 9438"
            d="M909.256 393.419L897.131 412a.894.894 0 00.673 1.378l21.264 1.826a1.038 1.038 0 001.03-1.466 45.629 45.629 0 01-9.285-20.186.892.892 0 00-1.557-.128z"
            transform="translate(-658.272 -288.428)"
            fill="url(#prefix__X)"
          />
          <path
            data-name="Path 9439"
            d="M670.445 1383.046a1.4 1.4 0 00-.04-.391c-1.948-7.718-11.617-12.535-11.617-12.535l-3.832.3c-2.2 6.808-1.919 10.983-1.565 12.844a.622.622 0 00.037.152 91.026 91.026 0 0017.017-.37z"
            transform="translate(-479.326 -1005.493)"
            fill="#4F52FF"
          />
          <path
            data-name="Path 9440"
            d="M174.102 377.923a1.666 1.666 0 001.216 1.227c4.5.945 11.643.184 14.637-.208a1.392 1.392 0 001.155-1.389 90.96 90.96 0 01-17.008.37z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 9441"
            d="M654.15 1349.8l1.623 7.813a1.28 1.28 0 001.091 1.051 10.919 10.919 0 002.515-.04 1.6 1.6 0 001.272-1.887l-1.128-6.938z"
            transform="translate(-480.061 -990.581)"
            fill="url(#prefix__g)"
          />
          <path
            data-name="Path 9442"
            d="M207.715 377.824c-4.232-.12-6.422-.617-7.553-1.081v1.294a.838.838 0 00.8.849l23.236-.149a1.062 1.062 0 00.854-1.546c-3.036.253-10.796.814-17.337.633z"
            fill="#7d97f4"
          />
          <path
            data-name="Path 9443"
            d="M777.022 1385.935a1.234 1.234 0 00-.093-.176c-2.052-2.866-7.279-8.575-17.607-11.052l-4.953-.157s-2.206 3.835-2.249 10.938c1.131.463 3.321.961 7.553 1.08 6.541.181 14.302-.38 17.349-.633z"
            transform="translate(-551.958 -1008.744)"
            fill="#4F52FF"
          />
          <path
            data-name="Path 9444"
            d="M756.29 1342.811c.077.367 1.107 5.924 1.506 8.08a1.08 1.08 0 00.969.916 11.339 11.339 0 003.393-.266 1.466 1.466 0 001.017-1.538l-.554-8.783z"
            transform="translate(-555.018 -984.284)"
            fill="url(#prefix__aa)"
          />
          <path
            data-name="Path 9445"
            d="M655.389 940.069s6.816 46.839 11.734 102.561a2.122 2.122 0 01-1.754 2.156 25.656 25.656 0 01-5.541.641 2.052 2.052 0 01-1.956-1.714c-1.677-9.826-13.631-62.559-16.766-74.165 0 0-3.606 49.3-2.454 74.878a1.214 1.214 0 01-1.065 1.262 20.507 20.507 0 01-4.447-.013 1.626 1.626 0 01-1.445-1.379c-1.192-8.314-8.064-57.814-7.771-93.473.016-2.009 2.361-18.533 2.361-18.533z"
            transform="translate(-457.873 -684.183)"
            fill="#09005D"
          />
          <path
            data-name="Path 9446"
            d="M623.244 728.446a1.929 1.929 0 01-1.267-1.623c-.9-8.782-5.293-63.312 22.411-85.739 0 0 1.6-4.157 14.637 6.063s6.068 20.928 2.941 35.7c-3.784 17.876-10.422 32.489-7.484 43.488a1.528 1.528 0 01-.934 1.828 43.222 43.222 0 01-30.304.283z"
            transform="translate(-455.864 -469.861)"
            fill="#4042E2"
          />
          <path
            data-name="Path 9447"
            d="M718.464 582c0 .777-11.074 16.5-11.074 16.5s1.988 3.909 11.465 7.084l8.183-16.822z"
            transform="translate(-519.132 -427.115)"
            fill="url(#prefix__ad)"
          />
          <path
            data-name="Path 9448"
            d="M738.191 548.18s3.936 9.048 4.2 13.788 1.285 7.824-4.2 8.782-10.113-1.781-12.615-6.507c0 0-3.923-7.284-3.042-10.267s15.657-5.796 15.657-5.796z"
            transform="translate(-530.152 -402.296)"
            fill="#FF928E"
          />
          <path
            data-name="Path 9449"
            d="M707.969 533.623l.311-.139a.75.75 0 00.367-1.035c-.772-1.5-2.281-4.921-.333-5.719 2.512-1.03 12.46-3.061 14.608-6.589a6.571 6.571 0 00-2.512-9.019.38.38 0 00-.495.162l-.229.434a.375.375 0 01-.689-.072.37.37 0 00-.671-.1c-.66 1.065-2.44 2.768-7.2 3.649-6.77 1.248-11.247 3.992-11.358 8.665a.373.373 0 01-.578.309c-.5-.3-1.3-.447-2.369.452-1.863 1.562-1.1 5.618 2.978 8.953a.373.373 0 01-.016.6c-.74.482-1.842 1.626 1.011 3.151a9.631 9.631 0 006.007 1.309.375.375 0 00.3-.45l-.9-4.112a.372.372 0 01.365-.452z"
            transform="translate(-510.668 -375.073)"
            fill="#09005D"
          />
          <path
            data-name="Path 9450"
            d="M728.362 586.746s-1.5-5.778-4.09-4.157 1.331 6.472 3.425 6.688z"
            transform="translate(-530.893 -427.337)"
            fill="url(#prefix__ag)"
          />
          <path
            data-name="Path 9451"
            d="M779.21 684l.764 20.492a55.938 55.938 0 006.193 1.757 61.966 61.966 0 016.147-12.418A30.443 30.443 0 01779.21 684z"
            transform="translate(-571.839 -501.97)"
            fill="#4042E2"
          />
          <path
            data-name="Path 9452"
            d="M839.026 682.68c-11.164 12.053-20.2 12.774-27.528 10.172a61.966 61.966 0 00-6.148 12.418c29.806 6.573 36.832-20.833 36.832-20.833z"
            transform="translate(-591.022 -501.001)"
            fill="url(#prefix__ai)"
          />
          <path
            data-name="Path 9453"
            d="M940.4 673.97a4.091 4.091 0 013.665-.945c2.379.434 4.5 1.259 5.983 0s2 .431 2 .431l-4.441 3.375z"
            transform="translate(-690.131 -493.574)"
            fill="url(#prefix__aj)"
          />
          <path
            data-name="Path 9454"
            d="M930.42 677.809s.881-3.686 3.537-3.194 8.684 3.782 10.235 3.194 3.542-2.06 4.561-1.528l-1.8 2.233s4.615-2.661 5.411-1.027l-7.689 4.309s-11.224-1.124-14.255-3.987z"
            transform="translate(-682.807 -495.05)"
            fill="#FEB3B1"
          />
          <path
            data-name="Path 9455"
            d="M732.65 748.21s20.987 17.564 43.645 9.908a5.41 5.41 0 014.258.322l6.517 3.441a5.815 5.815 0 007.718-2.158 12.214 12.214 0 001.831-4.9l-12.748-5.16.939-1.562s-6.225-.532-7.853 3.933c0 0-11.856 4.931-31.853-17.062-.004.006-9.079 7.728-12.454 13.238z"
            transform="translate(-537.67 -539.375)"
            fill="#FF928E"
          />
          <path
            data-name="Path 9456"
            d="M691.81 739.152a.345.345 0 01-.2-.061c-8.838-5.972-12.995-15.609-13.04-15.7a.359.359 0 11.66-.282c.04.1 4.12 9.543 12.774 15.39a.359.359 0 01-.2.657z"
            transform="translate(-497.961 -530.509)"
            fill="url(#prefix__am)"
          />
          <path
            data-name="Path 9457"
            d="M926.918 763.879s-1.945-5.11-4.215-4.652a15.443 15.443 0 00-4.764 2.2l-3.649 4.937s10.243 4.035 13.839 1.722a78.93 78.93 0 0023.686-.359 51.84 51.84 0 01-3.726-11.22c-6.689 3.801-13.889 6.63-21.171 7.372z"
            transform="translate(-670.97 -555.183)"
            fill="#FEB3B1"
          />
          <path
            data-name="Path 9458"
            d="M1075.573 644.68s-14.98 18.869-34.243 29.772a51.845 51.845 0 003.726 11.22c9.993-1.642 21.557-5.554 31.366-14.251z"
            transform="translate(-764.201 -473.114)"
            fill="#FE7062"
          />
          <path
            data-name="Path 9459"
            d="M1183.53 720.178c-2.927-13.916-5.855-21.972-15.667-48.348-3.087-8.3-5.892-16.7-4.524-25.45l1.519-9.828s19.063-6.451 40.186-.266c0 0 9 11.345 9.245 74.378-8.824 9.867-19.155 12.683-30.759 9.514z"
            transform="translate(-853.478 -464.986)"
            fill="#FE7062"
          />
          <path
            data-name="Path 9460"
            d="M1182.19 588.836l4.942 11.875a2.368 2.368 0 001.788 1.424c2.85.487 9.743 1.251 14.27-1.725a1.152 1.152 0 00.306-1.618l-9.131-13.112z"
            transform="translate(-867.574 -429.816)"
            fill="#FEB3B1"
          />
          <path
            data-name="Path 9461"
            d="M1177.234 527.5c-.208.194-8.764 16.992-8.764 16.992l9.7 4.681 10.475-14.717s-7.936-10.226-11.411-6.956z"
            transform="translate(-857.505 -386.643)"
            fill="#FEB3B1"
          />
          <path
            data-name="Path 9462"
            d="M1176.81 517.049l-4.836 8.058a1.448 1.448 0 01-.266.33c-.575.532-2.544 2.094-4.066-.027-1.3-1.807-2.515-3.46-3.819-4.13a1.544 1.544 0 00-2.087.687 57.74 57.74 0 00-3.311 7.851 1.539 1.539 0 00.9 1.887 43.013 43.013 0 009.285 2.709 1.545 1.545 0 001.464-.623c1.48-2.028 5.655-7.7 7.079-9.118 1.331-1.331 3.768-.822 4.87-.506a1.556 1.556 0 001.235-.162c1.118-.673 3.066-2.35 1.283-5.184a1.546 1.546 0 01.479-2.1 3.422 3.422 0 001.309-4.854 4.857 4.857 0 00-5.221-2.557 1.6 1.6 0 01-1.684-.937 1.02 1.02 0 00-.8-.628 1.5 1.5 0 01-1.216-1.764 3.978 3.978 0 00-2.212-4.538c-4.184-2.3-7.845 1.448-8.782 4.612s3.747 5.4 6.688 5.772c2.161.266 3.348 2.632 3.824 3.864a1.551 1.551 0 01-.116 1.358z"
            transform="translate(-850.083 -367.474)"
            fill="#1A0F91"
          />
          <path
            data-name="Path 9463"
            d="M1221.33 586.8s2.081-4.894 4.463-4.695 4.258 2.571 1.3 5.237c-3.669 3.315-5.763-.542-5.763-.542z"
            transform="translate(-896.297 -427.187)"
            fill="url(#prefix__as)"
          />
          <path
            data-name="Path 9464"
            d="M328.175 377.829c4.6.4 12.6 1.043 18.9 1.331 3.787.165 5.967-.2 7.223-.708v.4a1.3 1.3 0 01-1.238 1.229 221.367 221.367 0 01-24.75.027.929.929 0 01-.756-1.395 7.509 7.509 0 01.621-.884z"
            fill="#91b3fa"
          />
          <path
            data-name="Path 9465"
            d="M1252.035 1395.4c-6.3-.266-14.291-.926-18.9-1.331 4.524-5.554 18.9-9.3 18.9-9.3h4.058a17.039 17.039 0 013.165 9.911c-1.258.512-3.436.881-7.223.72z"
            transform="translate(-904.965 -1016.245)"
            fill="url(#prefix__at)"
          />
          <path
            data-name="Path 9466"
            d="M1301.128 1359.9l-.378 7.516a1.717 1.717 0 01-1.467 1.613 6.651 6.651 0 01-3.047-.25 2.026 2.026 0 01-1.365-1.562l-1.312-7.316z"
            transform="translate(-949.305 -997.993)"
            fill="url(#prefix__au)"
          />
          <path
            data-name="Path 9467"
            d="M404.518 379.093a3.625 3.625 0 003.279-2.424v.032a2.588 2.588 0 01-1.748 2.957 11.4 11.4 0 01-4.841.758 4.811 4.811 0 01-3.63-1.674v-.016c1.5.745 3.61.833 6.94.367z"
            fill="#91b3fa"
          />
          <path
            data-name="Path 9468"
            d="M1477.942 1359.718h3.345c5.1-.1 8.3 10.645 9.346 14.81a3.64 3.64 0 01-3.279 2.424c-3.329.466-5.44.378-6.946-.367-2.752-3.622-4.12-8.931-4.774-12.029a4.223 4.223 0 012.308-4.838z"
            transform="translate(-1082.838 -997.859)"
            fill="url(#prefix__av)"
          />
          <path
            data-name="Path 9469"
            d="M1475.944 1333.51l1.863 7.393a2 2 0 01-1.043 2.273 7.132 7.132 0 01-3.848.932 1.678 1.678 0 01-1.368-1.118l-2.728-7.776z"
            transform="translate(-1077.923 -978.626)"
            fill="url(#prefix__aw)"
          />
          <path
            data-name="Path 9470"
            d="M1308.344 1035.6c-2.313 2.052-9.847 2.321-9.847 2.321-27.087-65.013-38.381-82.91-38.381-82.91 3.912 24.54.843 87.527.843 87.527-4.471 1.972-10.232 0-10.232 0-.365-40.186-6.02-83.344-13.307-110.963 18.307-.412 28.258-4.4 31.438-6.919 15.265 24.608 39.486 110.944 39.486 110.944z"
            transform="translate(-908.106 -678.583)"
            fill="#1A0F91"
          />
          <rect
            data-name="Rectangle 1275"
            width={40.292}
            height={58.618}
            rx={5.53}
            transform="translate(284.741 183.156)"
            fill="#4F52FF"
          />
          <rect
            data-name="Rectangle 1276"
            width={38.267}
            height={56.968}
            rx={5.53}
            transform="translate(285.802 184.034)"
            opacity={0.78}
            fill="#E9EFFD"
          />
          <g
            data-name="Group 474"
            transform="translate(288.887 189.721)"
            opacity={0.78}
          >
            <rect
              data-name="Rectangle 1277"
              width={31.616}
              height={0.963}
              rx={0.482}
              fill="url(#prefix__az)"
            />
            <rect
              data-name="Rectangle 1278"
              width={31.616}
              height={0.963}
              rx={0.482}
              transform="translate(0 4.436)"
              fill="url(#prefix__k)"
            />
            <rect
              data-name="Rectangle 1279"
              width={31.616}
              height={0.963}
              rx={0.482}
              transform="translate(.24 9.088)"
              fill="url(#prefix__k)"
            />
            <rect
              data-name="Rectangle 1280"
              width={31.616}
              height={0.963}
              rx={0.482}
              transform="translate(.24 13.522)"
              fill="url(#prefix__az)"
            />
            <rect
              data-name="Rectangle 1281"
              width={31.616}
              height={0.963}
              rx={0.482}
              transform="translate(.12 18.318)"
              fill="url(#prefix__k)"
            />
            <rect
              data-name="Rectangle 1282"
              width={31.616}
              height={0.963}
              rx={0.482}
              transform="translate(.12 22.751)"
              fill="url(#prefix__k)"
            />
            <rect
              data-name="Rectangle 1283"
              width={31.616}
              height={0.963}
              rx={0.482}
              transform="translate(.359 27.403)"
              fill="url(#prefix__aA)"
            />
            <rect
              data-name="Rectangle 1284"
              width={31.616}
              height={0.963}
              rx={0.482}
              transform="translate(.359 31.84)"
              fill="url(#prefix__aB)"
            />
            <rect
              data-name="Rectangle 1285"
              width={20.338}
              height={0.963}
              rx={0.482}
              transform="translate(11.638 36.713)"
              fill="url(#prefix__aB)"
            />
            <rect
              data-name="Rectangle 1286"
              width={20.338}
              height={0.963}
              rx={0.482}
              transform="translate(12.12 41.466)"
              fill="url(#prefix__aB)"
            />
          </g>
          <path
            data-name="Path 9471"
            d="M1104.264 859.41c.082.29-.3 9.125-.364 10.765a.109.109 0 00.183.088l1.6-1.408 1.429 1.453a.186.186 0 00.317-.149l-1.009-10.674z"
            transform="translate(-810.118 -630.698)"
            fill="url(#prefix__aC)"
          />
          <path
            data-name="Path 9472"
            d="M1089.825 857.05c-.024.266-3 7.05-3.577 8.37a.072.072 0 00.107.091l2.057-1.331.418 2.292a.109.109 0 00.21 0l2.467-8.719z"
            transform="translate(-797.16 -628.966)"
            fill="url(#prefix__aD)"
          />
          <path
            data-name="Path 9473"
            d="M1092.607 839.663l.974-.833.551 1.157 1.229-.367.032 1.283 1.272.165-.492 1.184 1.094.668-.932.881.727 1.056-1.208.426.237 1.262-1.28-.1-.3 1.248-1.126-.612-.78 1.017-.777-1.017-1.125.612-.3-1.248-1.281.1.237-1.262-1.211-.426.729-1.056-.931-.881 1.094-.668-.492-1.184 1.272-.165.031-1.283 1.229.367.551-1.157z"
            transform="translate(-798.414 -615.595)"
            fill="url(#prefix__aE)"
          />
          <circle
            data-name="Ellipse 436"
            cx={3.414}
            cy={3.414}
            r={3.414}
            transform="rotate(-76.72 290.57 -68.002)"
            fill="url(#prefix__aF)"
          />
          <path
            data-name="Path 9474"
            d="M294.122 231.011a3.033 3.033 0 01-.562-.051.066.066 0 01-.053-.077.072.072 0 01.077-.053 2.994 2.994 0 003.526-2.928 2.958 2.958 0 00-.325-1.357.064.064 0 01-.006-.052.064.064 0 01.035-.039.066.066 0 01.088.029 3.08 3.08 0 01.341 1.418 3.124 3.124 0 01-3.121 3.11z"
            fill="#fff"
            opacity={0.31}
          />
          <path
            data-name="Path 9475"
            d="M291.085 227.633a.066.066 0 01-.059-.072 3.124 3.124 0 014.138-2.616.069.069 0 01.043.085.066.066 0 01-.085.04 2.992 2.992 0 00-3.963 2.5.064.064 0 01-.025.045.066.066 0 01-.049.014z"
            fill="#fff"
            opacity={0.31}
          />
          <path
            data-name="Path 9476"
            d="M1294.64 665.169l7.015-21.509s14.427 7.548 21.314 36.391a45.789 45.789 0 00-17.349 1.533c-.042-8.003-10.98-16.415-10.98-16.415z"
            transform="translate(-950.098 -472.366)"
            fill="url(#prefix__aG)"
          />
          <path
            data-name="Path 9477"
            d="M1209.389 780.538s19.281 15.851 28.313 6.792a8.3 8.3 0 002.6-6.046 45.789 45.789 0 0117.349-1.533 23.007 23.007 0 01-5.189 15.105c-16.713 20.918-46.839-9.538-46.839-9.538z"
            transform="translate(-884.768 -572.065)"
            fill="#FEB3B1"
          />
          <path
            data-name="Path 9478"
            d="M1180.954 763.053s2.8-6.406 2.563-8.894-.977-5.764-5.323-5.828a63.5 63.5 0 00-9.671.841 2.463 2.463 0 003.106 2.7l-2.27 1.195s-.149 2.526 2.8 1.682l-2.217 1.722a2.2 2.2 0 003.042 1.285c2.235-.949 2.152 5.106 7.97 5.297z"
            transform="translate(-857.539 -549.178)"
            fill="#FEB3B1"
          />
          <path
            data-name="Path 9479"
            d="M1301.339 733.561a.138.138 0 01-.136-.112c-1.038-6.092-4.969-12.1-12.37-18.917a.139.139 0 010-.192.136.136 0 01.192 0c7.452 6.858 11.406 12.915 12.455 19.068a.135.135 0 01-.112.157z"
            transform="translate(-945.808 -524.207)"
            fill="url(#prefix__aJ)"
          />
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
